import {SERVICES} from './services';

export const API_URLS = {
  CONFIG_PRODUCTS: '/public/products-plus',
  COIN_BASIC_LIST: '/phemex-common-service/public/data/coin/basic/list',
  PILOT_COIN_INFO: '/phemex-common-service/public/data/coin/pilot-info-list',
  PROMOTIONS: '/phemex-user/public/promotions',
  FEE_CONDITION: '/phemex-user/public/fees-conditions',
  ACTIVITY_CONTENTS_VIEW_LOGOUT: '/phemex-activity/public/data/contents/list',
  ACTIVITY_CONTENTS_VIEW_LOGIN: '/phemex-activity/contents/list',
  SYSTEM_TIME: '/public/time',
  SAVE_REFERRAL_CODE: '/phemex-user/public/referral-code/save',

  // kline
  KLINE: '/phemex-user/public/md/kline',
  KLINE_V2: '/phemex-user/public/md/v2/kline/list',

  TREND: '/phemex-user/public/md/trend',
  TREND_V2: '/phemex-user/public/md/v2/trend',
  BROWSE_TIME: '/phemex-activity/contents/browse-time',

  // Email code
  PUBLIC_CODES_MAIL: '/phemex-user/public/codes/mail',
  CODES_MAIL: '/phemex-user/codes/mail',

  //user
  SELF: '/tokens/self',
  USERS_SELF: '/phemex-user/users/self',
  USERS_LOGOUT: '/phemex-user/users/logout',
  USER_LOGIN: '/phemex-user/users/login',
  USERS_CONFIRM_LOGIN: '/phemex-user/users/v2/confirm/login',
  USER_SIGNUP: '/phemex-user/users/register',
  USERS_CONFIRM_REGISTER: '/phemex-user/users/v2/confirm/register',
  PREPARE_PASSWORD: '/phemex-user/users/prepare/resetPassword',
  CONFIRM_PASSWORD: '/phemex-user/users/confirm/resetPassword',
  PREFERENCE: '/phemex-user/users/preference',
  DELETE_ACCOUNT: '/phemex-user/users/deleteAccount',
  PUBLIC_GEO: '/phemex-user/public/geo',
  PUBLIC_GEO_V2: '/phemex-user/public/v2/geo',
  GOOGLE_CLIENT_ID: '/phemex-user/users/google-client-id',
  USER_DEVICES: '/phemex-user/users/device/list',
  USER_DEVICE_HISTORY: '/phemex-user/users/device/history/list',
  DELETE_USER_DEVICE: '/phemex-user/users/device/delete',
  USER_GROWTH_INFO: '/phemex-user/users/member',
  USER_LEVEL_NOTIFICATIONS: '/phemex-user/users/member/confirm/level-notification-list',
  USER_LEVEL_NOTIFICATIONS_CONFIRM: '/phemex-user/users/member/confirm/level-notification',
  USER_ACHIEVEMENTS: '/phemex-user/users/member/achievements',
  USER_GROWTH_HISTORIES: '/phemex-user/users/member/growth-point-txns',
  PROFIT_EMAIL_NOTIFICATION: '/phemex-wm/wm-settings/profit-email-notification',
  DELETE_APPLY: '/phemex-user/users/delete-account/apply',
  DELETE_SAVE_ASSET: '/phemex-user/users/delete-account/save-asset-decision',
  DELETE_CONFIRM: '/phemex-user/users/delete-account/confirm',
  USER_AVATAR: '/phemex-user/users/avatars',
  USERS_AUTH_LOGIN: '/phemex-user/users/auth/login',
  CONFIRM_USERS_AUTH_LOGIN: '/phemex-user/users/auth/confirm/login',
  OAUTH_TRADINGVIEW_AUTHORIZE: '/phemex-oauth2/oauth2/user/authorize',
  OAUTH_LIST: '/phemex-oauth2/oauth2/user/list',
  OAUTH_INFO: '/phemex-oauth2/public/cfg/client',
  OAUTH_INVALID: '/phemex-oauth2/oauth2/user/invalid',
  GET_TWITTER_CLIENT_ID: '/phemex-user/public/cfg/users/auth/client-id',
  USER_SOCIAL_AVATAR: '/phemex-user/public/cfg/users/auth/refresh-social-avatar',
  USER_QR_LOGIN: '/phemex-user/users/public/qr/login',
  USER_QR_CHECK: '/phemex-user/users/public/qr/login/check',
  USER_QR_CONFIRM_LOGIN: '/phemex-user/users/qr/confirm/login',
  USER_PROFILE_META: '/phemex-user/users/profile',
  USER_COUNTRY_BY_IP: '/phemex-user/public/v2/geo',

  // telegram
  TELEGRAM_BIND_STATUS: '/phemex-user/users/social/query',
  TELEGRAM_BIND: '/phemex-user/users/social/bind',
  TELEGRAM_UNBIND: '/phemex-user/users/social/unbind',
  TELEGRAM_BOT_INFO: '/phemex-user/public/social/queryName',

  // wallet
  WALLETS: '/phemex-user/wallets',
  USER_WALLET_LIST: '/phemex-user/wallets/userWalletList',

  FEE_RATE_CONTRACT: '/phemex-user/fee-rate/contract',
  // Account & Sub-accounts
  USER_CHILDREN: '/phemex-user/users/children',
  USER_CHILDREN_V2: '/phemex-user/users/v2/children',
  USER_CHILDREN_UTA: '/phemex-user/users/uta-children',
  USER_SWITCH: '/phemex-user/users/switch',
  USER_SWITCHBACK: '/phemex-user/users/switchBack',
  SWITCH_ACCOUNT: '/phemex-user/users/children/basic/info',
  CHILDREN_ASSETS: '/phemex-user/users/children/assets',
  CHILDREN_ASSETS_V2: '/phemex-user/users/v2/children/assets',
  CHILDREN_ASSETS_UTA: '/phemex-user/users/children/uta-assets',
  SUB_ACCOUNT_SWITCH: '/phemex-user/users/switch',
  MASTER_ACCOUNT_SWITCHBACK: '/phemex-user/users/switchBack',
  REFERRALS: '/phemex-kol-global/agent/apply',
  AGENT_APPLY_INFO: '/phemex-kol-global/agent/apply/info',
  WALLETS_TRANSFERIN: '/phemex-user/wallets/transferIn',
  TRANSFER_OUT: '/phemex-user/wallets/transferOut',
  UPLOAD_AVATAR: '/phemex-user/users/uploadAvatarImage',
  // transfer account
  SPOT_MAIN_ACCOUNT_TO_SUB_ACCOUNT: '/exchanger-core/wallets/spot/transfer-out',
  SPOT_SUB_ACCOUNT_TO_SUB_ACCOUNT: '/exchanger-core/wallets/spot/sub2sub-transfer',
  SPOT_SUB_ACCOUNT_TO_MAIN_ACCOUNT_: '/exchanger-core/wallets/spot/transfer-in',
  CONTRACT_MAIN_ACCOUNT_TO_SUB_ACCOUNT: '/exchanger-core/wallets/contract/transfer-out',
  CONTRACT_SUB_ACCOUNT_TO_SUB_ACCOUNT: '/exchanger-core/wallets/contract/sub2sub-transfer',
  CONTRACT_SUB_ACCOUNT_TO_MAIN_ACCOUNT: '/exchanger-core/wallets/contract/transfer-in',
  ACCOUNT_TRANSFER_MAIN_SUB: '/exchanger-core/wallets/account/main-sub-transfer',
  // Account & Api-management
  KEYS_LIST: '/phemex-user/users/keys/list',
  KEYS_CREATE: '/phemex-user/users/keys/create',
  KEYS_DELETE: '/phemex-user/users/keys/delete',
  KEYS_DETAIL: '/phemex-user/users/keys/query',
  KEYS_UPDATE: '/phemex-user/users/keys/modify',
  KEYS_REFRESH: '/phemex-user/users/keys/refresh',
  KEYS_SYNC_TO_SUB_ACCOUNTS: '/phemex-user/users/keys/sync',
  // Account & Recommend-phemex
  PERSONAL_RECOMMEND_INFO: '/phemex-user/referrals/summary',
  RECOMMEND_RECORD_LIST: '/phemex-user/referrals/v2/bonus',
  //Premium
  BASE_MEMBERSHIP_INFO: '/phemex-user/membership/baseMembershipInfo',
  UPDATE_AUTORENEW_CONFIG: '/phemex-user/membership/updateAutoRenewConfig',
  GROWTH_CONFIG: '/phemex-user/users/public/member/info/growth-config',
  GROWTH_TASKS: '/phemex-user/users/member/growth-tasks',

  //referrals
  REFERRALS_COUNTRY: '/phemex-user/public/regions',
  PRIVACY_LANG: '/phemex-user/public/compliance/privacy/lang',
  ADD_GROUP_CLICK_CNT: '/phemex-kol-global/public/agent/group/click',
  RANK_LIST: '/phemex-activity/activity/referral/rankList',
  RANK_LIST_AUGUST: '/phemex-activity/activity/referral/v2/rankList',

  // Assets & overview
  MARGIN_TRANSFER_LIST: '/phemex-user/margins/transfer',
  MARGIN: '/phemex-user/margins/v2',
  INDEX_QUOTE: '/phemex-user/margins/v2/quote',
  EARLY_REDEMPTION: '/phemex-wm/wm-order/timed-redemption',
  EARLY_REDEMPTION_APY_RATE: '/phemex-wm/public/product/redeem-rate',
  WITHDRAW_MAIL_CODE: '/phemex-withdraw/wallets/withdraw-mail-code',

  WALLETS_APP_V4_CREATEWITHDRAW: '/phemex-withdraw/wallets/app/v4/createWithdraw',
  WALLETS_APP_V5_CREATEWITHDRAW: '/phemex-withdraw/wallets/app/v5/createWithdraw',
  WALLETS_INSIDE_V2_CREATE: '/phemex-withdraw/wallets/inside/v2/create',
  WALLETS_INSIDE_V3_CREATE: '/phemex-withdraw/wallets/inside/v3/create',
  WITHDRAW_MAIL_CODE_ONCHAIN: '/phemex-withdraw/wallets/app/onchain-withdraw-mail-code',
  WITHDRAW_MAIL_CODE_INTERNAL: '/phemex-withdraw/wallets/inside/internal-withdraw-mail-code',
  // Assets & deposit
  DEPOSIT_LIST: '/phemex-deposit/app/deposits/depositList',
  DEPOSIT_NETWORKS_LIST: '/phemex-deposit/app/deposits/network/support/list',
  DEPOSIT_ADDRESS: '/phemex-user/wallets/v2/depositAddress',
  DEPOSIT_ADDRESS_V3: '/phemex-user/wallets/v3/depositAddress',
  DEPOSIT_SORT_LIST: '/phemex-withdraw/withdraw/asset/info/public/currency/prop',
  // Assets & withdrawal
  WITHDRAW_LIST: '/phemex-user/wallets/withdrawList',
  WITHDRAW_FEE_INFO: '/phemex-withdraw/withdraw/asset/info/public/balance/fee/query',
  WITHDRAW_FEE_INFO_V2: '/phemex-withdraw/withdraw/asset/info/public/balance/fee/v2/query',
  WITHDRAW_KYC_LIMIT: '/phemex-withdraw/wallets/app/getWithdrawKycLimit',
  WITHDRAW_SORT_LIST: '/phemex-withdraw/wallets/app/currency/hot/list',
  WITHDRAW_KYC_LIMIT_CHECK: '/phemex-withdraw/wallets/app/kyc-limit/check',
  WITHDRAW_KYC_LIMIT_CHECK_V2: '/phemex-withdraw/wallets/app/kyc-limit/check/v2',
  CANCEL_WITHDRAW: '/phemex-withdraw/wallets/app/cancelWithdraw',
  CREATE_WITHDRAW: '/phemex-withdraw/wallets/app/createWithdraw',
  CREATE_WITHDRAWADDRESS: '/phemex-withdraw/wallets/v2/createWithdrawAddress',
  WITHDRAWAL_CONFIRM: '/phemex-user/wallets/confirm/withdraw',
  VALIDATE_ADDRESS: '/phemex-withdraw/wallets/app/validate-address',
  SUCCESS_WITHDRAW_ORDER: '/phemex-withdraw/wallets/app/succeed',
  SUCCESS_DEPOSIT_ORDER: '/phemex-deposit/app/deposits/succeed',
  DEPOSITS_CHECK_TO_CONTRACT: '/phemex-deposit/app/deposits/contract/check', // 校验币种是否支持入金合约
  DEPOSITS_ACCOUNT_UPDATE: '/phemex-deposit/app/deposits/account/update', // 修改入金账户	POST
  ASSETS_ANNOUNCEMENT: '/phemex-withdraw/app/banner/query',
  WITHDRAW_LIMIT_P2P: '/phemex-withdraw/withdraw/asset/info/public/p2p/withdraw/limit/by/user', // 根据用户id 判断p2p 24小时限额是否启用
  WITHDRAW_P2P_FROZEN: '/phemex-withdraw/withdraw/asset/info/public/p2p/withdraw/frozen/query', // 查询用户P2P 24小时冻结资产
  WITHDRAW_ASSET_FROZEN_TOTAL: '/phemex-withdraw/withdraw-assets/frozen-assets', // 查询用户 24小时冻结资产

  WITHDRAW_INTERNAL_ADDRESS_VALIDATE: '/phemex-withdraw/wallets/inside/address/validate',
  WITHDRAW_INTERNAL_ADDRESS: '/phemex-withdraw/wallets/inside/address',
  WITHDRAW_INTERNAL_ADDRESS_V2: '/phemex-withdraw/wallets/inside/v2/address',
  WITHDRAW_INTERNAL_ADDRESS_CREATE: '/phemex-withdraw/wallets/inside/create',
  WITHDRAW_INTERNAL_ADDRESS_WITHDRAW_LIST: '/phemex-withdraw/wallets/app/withdrawList',
  WITHDRAW_INTERNAL_ADDRESS_INSIDE_PROP: '/phemex-withdraw/wallets/inside/prop',

  // Assets & fund-details
  // WALLET_DETAIL: '/phemex-user/wallets/detail',
  WALLET_DETAIL: '/phemex-user/wallets/spot/detail',
  TRADE_ACCOUNT_DETAIL_V2: '/phemex-user/wallets/v2/tradeAccountDetail',
  // Assets & pnl-details
  PNL_POSITION: '/phemex-user/margins/data/pnl/position',
  PNL_POSITION_V2: '/phemex-user/margins/data/v2/pnl/position',
  PNL_ACCOUNT: '/phemex-user/margins/data/pnl/account',
  PNL_ACCOUNT_V2: '/phemex-user/margins/data/v2/pnl/account',
  CLOSED_POSITIONS: '/phemex-user/order/closedPositionList',
  CLOSED_POSITIONS_V2: '/phemex-user/order/v2/closedPositionList',
  EXCHANGE_FEE_LIST: '/phemex-user/order/exchangeFeeList',
  EXCHANGE_FEE_LIST_V2: '/phemex-user/order/v2/exchangeFeeList',
  FUNDING_FEE_LIST: '/phemex-user/order/fundingList',
  FUNDING_FEE_LIST_V2: '/phemex-user/order/v2/fundingList',
  // Assets & order-history
  ORDER_LIST: '/phemex-user/order/orderList',
  ORDER_LIST_V2: '/phemex-user/order/v2/orderList',
  // Assets & trade-history
  TRADE_LIST: '/phemex-user/order/tradingList',
  TRADE_LIST_V2: '/phemex-user/order/v2/tradingList',

  // Assets & spot & order-history
  SPOT_ORDER_LIST: '/phemex-user/spot/order',
  // Assets & spot & trade-history
  SPOT_TRADE_LIST: '/phemex-user/spot/order/trades',
  // Assets & spot & pnl-history
  SPOT_PNL_DATA: '/phemex-user/spot/data/pnl/graph-v2',
  SPOT_CURRENT_PNL: '/phemex-user/spot/data/assets',
  CHAIN_SETTINGS: '/phemex-user/public/cfg/chain-settings',
  ASSETS_GRAPH: './phemex-user/users/assets/graph',

  // Contract
  CONTRACT_INTRODUCTION: '/phemex-user/public/instruments/contractIntroduction',
  INSURANCE_MAP: '/phemex-user/public/insurance/insuranceMap',
  INSURANCE_LIST: '/phemex-user/public/insurance/insuranceList',
  INSURANCE_LIST_V2: '/phemex-user/public/insurance/v2/insuranceList',
  FUNDING_RATE_LIST: '/phemex-user/public/cfg/fundingRateList',
  CURRENT_FUNDING_RATE_LIST: '/contract-biz/public/real-funding-rates',
  FUNDING_RATE_DATE_ALL: '/phemex-user/public/cfg/fundingRates/all',
  CONTRACT_TRANSFER_CURRENCIES: '/public/supported-currencies',
  CONTRACT_CONVERT: '/exchanger-core/wallets/contract/transfer-convert-transfer',

  // member
  SHARE_TIMES: '/phemex-user/membership/availablePresentQuantity',
  SHARE_HISTORY_LIST: '/phemex-user/membership/listPresentHistory',
  SHARE: '/phemex-user/membership/share',
  RECEIVE_LIST: '/phemex-user/membership/availableMembershipsFromPresent',
  RECEIVE: '/phemex-user/membership/drawMembershipFromPresent',
  COMPLETE_TASK: '/phemex-user/membership/completeTask',
  PREMIUM_LIST: '/phemex-marketing/premium/template',
  MARKETING_PRIVILEGE_USE: '/phemex/marketing/privilege/use',

  // Premium
  USER_TASKS: '/phemex-user/membership/userTasks',
  MEMBERSHIP_PURCHASE_PLANS: '/phemex-user/membership/view/membershipPurchasePlans',
  MEMBERSHIP_PURCHASE: '/phemex-user/membership/purchase',
  SUPPORT_CURRENCY: '/phemex-user/membership/view/membershipConfig',
  USER_KYC_INFO: '/phemex-user/membership/user-kyc-info',

  // Account & Security
  UPDATE_PROFILE: '/phemex-user/users/updateProfile',
  TASKS_LIST: '/phemex-user/tasks/list',
  USER_CHANGE_PASSWORD: '/phemex-user/users/change/password',
  USER_OTP: '/phemex-user/users/otp',
  OTP_BIND: '/phemex-user/users/otp/bind',
  OTP_CONFIRMBIND: '/phemex-user/users/otp/confirmBind',
  OTP_CONFIRMUNBIND: '/phemex-user/users/otp/confirmUnbind',
  OTP_UNBIND: '/phemex-user/users/otp/unbind',
  // Account & Sub-accounts
  CHILDREN_EMAIL: '/phemex-user/users/children/email',
  //  get support currency list
  PUBLIC_MISC: '/phemex-user/public/misc',
  GENERAL_TICKLING: '/phemex-activity/general/tickling',
  UPLOAD_IMAGE: '/phemex-activity/s3/image',
  WALLETS_APP_PRE_CHECK: '/phemex-withdraw/wallets/app/pre-check',

  //Download
  DOWNLOAD_CONTRACT_ORDER: '/phemex-user/order/download/orderList',
  DOWNLOAD_CONTRACT_ORDER_V2: '/phemex-user/order/v2/download/orderList',
  DOWNLOAD_CONTRACT_TRADE: '/phemex-user/order/download/tradingList',
  DOWNLOAD_CONTRACT_TRADE_V2: '/phemex-user/order/v2/download/tradingList',
  DOWNLOAD_SPOT_ORDER: '/phemex-user/spot/download/order',
  DOWNLOAD_SPOT_TRADES: '/phemex-user/spot/download/trades',
  DOWNLOAD_WALLET_DETAILS: '/phemex-user/wallets/spot/download/detail',
  DOWNLOAD_DEPOSIT: '/phemex-user/wallets/download/depositList',
  DOWNLOAD_WITHDRAW: '/phemex-user/wallets/download/withdrawList',

  //  buy-crypto
  BUY_CRYPTO_PLACE_ORDER_GOOGLE_APPLE_PAY: '/phemex-uni-trade/third-party/order/create',
  BUY_CRYPTO_PLACE_ORDER: '/phemex-user/fiatPayment/createPaymentOrder',
  SUPPORTED_CONFIG: '/phemex-user/fiatPayment/view/supportedConfig',
  SMART_PRICING: '/phemex-user/fiatPayment/smartPricing',
  SIMPLEX_PRE_ORDER_INFO: '/phemex-user/fiatPayment/simplex/preOrderInfo',
  BUY_CRYPTO_ORDER_HISTORY: '/phemex-uni-trade/third-party/orders',
  USER_CPFS: '/phemex-user/users/cpfs',
  BUY_CRYPTO_BANNER: '/phemex-uni-trade/banner/public/common-banners',
  BUY_CRYPTO_OTC_LEGEND_HISTORY: '/phemex-uni-trade/buy-crypto/otc-trade-req/list',
  LEGEND_BAN_IP_CHECK: '/phemex-uni-trade/legend/pre-process/ban-ip-check',

  // buy-crypto-card
  B2C_ORDERS: '/phemex-uni-trade/buy-crypto/b2c/order/list',
  PAYBIS_ORDERS: '/phemex-uni-trade/buy-crypto/inst/agent/order/list',
  B2C_BANK_CARD_LIST: '/phemex-uni-trade/channel/bank-card/list',
  DELETE_B2C_BANK_CARD: '/phemex-uni-trade/channel/bank-card/remove',
  B2C_BANK_CARD: '/phemex-uni-trade/channel/bank-card',
  B2C_BANK_CARD_SET_DEFAULT: '/phemex-uni-trade/channel/bank-card/default',
  B2C_PLACE_ORDER: '/phemex-uni-trade/buy-crypto/b2c/place-order',
  PAYBIS_PLACE_ORDER: '/phemex-uni-trade/buy-crypto/inst/agent/place-order',
  B2C_BIND_CARD_PLACE_ORDER: '/phemex-uni-trade/buy-crypto/b2c/place-order-for-bind-card',
  B2C_KYC_VALIDATE: '/phemex-uni-trade/buy-crypto/b2c/kyc-verify',
  B2C_KYC_MISSING_CONFIG: '/phemex-uni-trade/config/missing-kyc/v4',
  B2C_CREDIT_ORDER_FAILED: '/phemex-uni-trade/buy-crypto/b2c/credit/failed-set-order',
  B2C_FIAT_BANNER_LIST: '/phemex-uni-trade/general/banner/query_list',
  B2C_RISK_CHECK: '/phemex-uni-trade/third-party/risk-check',

  //bonus
  EXCHANGE_BONUS: '/exchange/bonus',
  EXCHANGE_BONUS_IP: '/phemex-common-service/public/geo/location',

  //HashClientId
  HASH_CLIENT_ID: '/phemex-user/users/hash-id',

  //trading contest
  SUMMARY: '/phemex-activity/public/data/competition/summary',
  TEAM_DETAIL_INFO: '/phemex-activity/public/data/competition/team-detail/team-info',
  TEAM_DETAIL_USER_LIST: '/phemex-activity/public/md/competition/team-detail/user-list',
  TEAM_JOIN: '/phemex-activity/competition/team/join',
  USER_INFO: '/phemex-activity/competition/self',
  TEAM_LEADER_APPLICATION: '/phemex-activity/competition/teamLeader/application',
  ROI_RANK: '/phemex-activity/competition/public/user/roi/rank',

  //  VIP && DMM
  PUB_VIP_APPLY: '/phemex-user/public/vip-mm/member/apply',
  VIP_APPLY: '/phemex-user/vip-mm/member/apply',
  VIP_CONFIG: '/phemex-user/public/cfg/vip-mm/vip/configs',
  DMM_CONFIG: '/phemex-user/public/cfg/vip-mm/mm/configs',
  VIP_LEVEL_LIST: '/phemex-user/public/vip-level/list',
  BIG_CLIENT_LIST: '/phemex-user/vip-mm/member/list',
  BIG_CLIENT_SELF: '/phemex-user/vip-mm/self',
  BIG_CLIENT_DOWNLOAD: '/phemex-user/vip-mm/details/download',
  APPLY_STATUS: '/phemex-user/vip-mm/member/apply/status',

  //investment
  INVESTMENT_PRODUCT: '/phemex-wm/public/product/v2/on-sale',
  INVESTMENT_PRODUCT_ONLY: '/phemex-wm/public/product/on-sale-act-only',
  INVESTMENT_ACCOUNT_INFO: '/phemex-wm/account/v2',
  INVESTMENT_ORDER: '/phemex-wm/wm-order',
  INVESTMENT_ORDER_AUTORENEW: '/phemex-wm/wm-order/autoRenew',
  INVESTMENT_TRANSFER: '/phemex-wm/account/asset/transfer',
  INVESTMENT_BUY: '/phemex-wm/wm-order',
  INVESTMENT_JOURNAL: '/phemex-wm/account/journal',
  USER_LOCATION: '/phemex-user/users/location',
  PRODUCT_ACTIVITY: '/phemex-wm/public/product/activity',
  INVESTMENT_BONUS_HISTORY: '/phemex-wm/wm-order/bonus/order-list', // 体验金历史
  INVESTMENT_BONUS_LIST: '/phemex-wm/account/bonus-list', // 体验金列表
  ASSETS_ACCOUNT: '/phemex-wm/account/v3',
  ACCOUNT_ACTIVITY: '/phemex-wm/account/activity',

  //trading-bonus
  BONUS_APPLY: '/phemex-activity/activity/apply',
  BONUS_BATCH_APPLY: '/phemex-activity/activity/batch/apply',
  BONUS_APPLY_RECORD: '/phemex-activity/activity/apply/record',
  BONUS_DETAIL: '/phemex-activity/public/data/activity/detail',
  BONUS_EFFECTIVE_TOP_UP: '/phemex-activity/bonus/effective-top-up',
  SUBMIT_TWITTER_INFO: '/phemex-activity/bonus/submit-twitter-info',
  TWITTER_PROCESS_STATUS: '/phemex-activity/bonus/twitter-process-status',

  REGISTER_VERIFIED: '/phemex-user/users/v2/confirm/registerWithToken',
  LOGIN_WITH_TOKEN: '/phemex-user/users/v2/confirm/loginWithToken',

  // OTC
  OTC_LEGEND_GEO: '/otc/legend/geo',
  OTC_LEGEND_PARAMS: '/otc/legend/page-params',
  OTC_KYC_CHECK: '/otc/legend/check-and-sync',
  OTC_KYC_APPROVED_STATUS: '/otc/legend/query-kyc-approved',
  OTC_KYC_APPROVED_STATUS_V2: '/otc/legend/query-kyc-approved/v3',
  OTC_DEPOSIT_ADDRESS: '/otc/legend/deposit-address',
  OTC_LEGEND_QUESTIONNAIRE: '/otc/legend/query-questionnaire/v3',
  SUBMIT_OTC_LEGEND_QUESTIONNAIRE: '/otc/legend/check-and-sync/v3',

  // KYC
  KYC_SUMMARY: '/phemex-kyc/kyc/summary',
  KYC_COUNTRIES: '/phemex-kyc/kyc/base-kyc/country-list',
  KYC_COUNTRY_DOCUMENT_TYPES: '/phemex-kyc/kyc/base-kyc/support-document',
  KYC_BASIC_INFO: '/phemex-kyc/kyc/base-kyc/query',
  KYC_BASIC_SUBMIT: '/phemex-kyc/kyc/base-kyc/submit',
  BASE_KYC_CHECK: '/phemex-kyc/kyc/base-kyc/check',
  GET_BONUS: '/phemex-activity/general/public/val',
  GET_ALL_KYC_SUMMAY: '/phemex-kyc/kyc/summary-all',
  KYC_COUNTRY_REGIONS: '/phemex-kyc/public/data/country-regions',
  BASIC_KYC_AMEND: '/phemex-kyc/kyc/basic-kyc/amend',
  BASIC_KYC_AMEND_PUBLIC: '/phemex-kyc/public/kyc/basic-kyc/amend',

  // KYB
  KYB_LEGEND_STATUS: '/phemex-uni-trade/fiat/kyb/status',
  KYB_LEGEND_STATUS_NOTIFY: '/phemex-uni-trade/fiat/kyb/status/notify',
  KYB_LEGEND_SUBMIT: '/phemex-uni-trade/fiat/kyb/submit',

  // KYC (jumio)
  KYC_CHECK_ENABLE: '/phemex-kyc/kyc/jumio/check-enable',
  KYC_JUMIO_TOKEN: '/phemex-kyc/kyc/jumio/token',
  KYC_JUMIO_TOKEN_PUBLIC: '/phemex-kyc/public/kyc/jumio/token',
  KYC_JUMIO_CHECK: '/phemex-kyc/kyc/jumio/check',
  KYC_JUMIO_CONFIG: '/phemex-kyc/public/data/config',
  KYC_JUMIO_CONFIG_WITH_LOGIN: '/phemex-kyc/kyc/config',
  KYC_JUMIO_GEN_CODE: '/phemex-kyc/kyc/general/start',
  KYC_JUMIO_VERIFY_CODE: '/phemex-kyc/public/kyc/general/verify',
  KYC_JUMIO_COLLECT_QUESTION: '/phemex-kyc/kyc/question/collect',
  KYC_JUMIO_COLLECT_QUESTION_PUBLIC: '/phemex-kyc/public/kyc/question/collect',
  KYC_RECOMMEND: '/phemex-kyc/kyc/recommend',
  KYC_UPLOAD_PROOF_ADDRESS_URL: '/phemex-kyc/kyc/get-upload-url',
  KYC_UPLOAD_PROOF_ADDRESS_FILE: '/phemex-kyc/kyc/upload-file',

  // QUIZ
  LEARN_LESSON_OVERVIEW_LOGOUT: '/phemex-activity/public/data/learn-and-earn/course/overview',
  LEARN_LESSON_OVERVIEW_LOGIN: '/phemex-activity/learn-and-earn/course/overview',
  LEARN_COURSE_DETAIL_LOGOUT: '/phemex-activity/public/data/learn-and-earn/course/detail',
  LEARN_COURSE_DETAIL_LOGIN: '/phemex-activity/learn-and-earn/course/detail',
  LEARN_QUIZ_LOGOUT: '/phemex-activity/public/data/learn-and-earn/quiz',
  LEARN_QUIZ_LOGIN: '/phemex-activity/learn-and-earn/quiz',
  LEARN_QUIZ_ANSWER: '/phemex-activity/learn-and-earn/quiz/answer',
  LEARN_QUIZ_COMPLETE: '/phemex-activity/learn-and-earn/quiz/complete',
  LEARN_QUIZ_RESULT: '/phemex-activity/learn-and-earn/learn-task-result',
  LEARN_QUIZ_ANSWER_ALL: '/phemex-activity/public/data/learn-and-earn/quiz-answer-all',
  LEARN_QUIZ_PERMIT: '/phemex-activity/public/learn-and-earn/permit',
  LEARN_BENEFIT: '/phemex-activity/public/learn-and-earn/benefit',
  LEARN_AND_EARN_LESSON_COUNT: '/phemex-activity/public/data/learn-and-earn/lesson/count',
  LEARN_AND_EARN_USER_LESSON_COUNT: '/phemex-activity/learn-and-earn/lesson/count',

  //reset-2fa
  PUBLIC_OTP_RESET: '/phemex-user/public/users/otp/reset',
  PUBLIC_OTP_CONFIRMRESET: '/phemex-user/public/users/otp/confirmReset',
  PUBLIC_OTP_RESET_QUESTIONS: '/phemex-user/public/users/otp/reset/questions',
  PUBLIC_OTP_RESET_QUESTIONS_JUDGE: '/phemex-user/public/users/otp/reset/questions/judge',
  PUBLIC_OTP_RESET_AUDIT: '/phemex-user/public/users/otp/reset/audit',
  OTP_RESET: '/phemex-user/users/otp/reset',
  OTP_CONFIRMRESET: '/phemex-user/users/otp/confirmReset',
  OTP_RESET_QUESTIONS: '/phemex-user/users/otp/reset/questions',
  OTP_RESET_QUESTIONS_JUDGE: '/phemex-user/users/otp/reset/questions/judge',
  OTP_RESET_AUDIT: '/phemex-user/users/otp/reset/audit',
  PUBLIC_UPDATE_IMAGE: '/phemex-activity/public/s3/image',
  PUBLIC_UPDATE_PRESIGN: '/phemex-user/public/users/otp/reset/presign/upload',
  PUBLIC_UPDATE_PRESIGN_DOWNLOAD: '/phemex-user/public/users/otp/reset/presign/download',

  // OFFLINE-DOWNLOAD
  OFFLINE_DOWNLOAD_CREATE: '/phemex-user/offline-download/create',
  OFFLINE_DOWNLOAD_QUERY: '/phemex-user/offline-download/query',
  OFFLINE_DOWNLOAD_LIMIT_CHECK: '/phemex-user/offline-download/limit-check',

  //KOL-CLIENT-DETAIL-DOWNLOAD
  KOL_CLIENT_EXPORT_QUERY: '/phemex-kol-global/client/export/list',
  KOL_CLIENT_EXPORT_CSV: '/phemex-kol-global/client/export/download',
  KOL_CLIENT_EXPORT_APPLY: '/phemex-kol-global/client/export/apply',

  // MO_TRADE_COMPETITION
  MO_COMPETITION_INFO: '/phemex-activity/public/data/competition/info',
  MO_COMPETITION_JOIN: '/phemex-activity/competition/members/join',
  MO_COMPETITION_SELF: '/phemex-activity/competition/members/self',
  MO_COMPETITION_RANK: '/phemex-activity/public/data/competition/members/sort',

  // crypto-converter
  CONVERSION_SUPPORTED_CURRENCIES: '/exchanger-core/wallets/public/data/conversion/supported-currencies',
  CONVERSION_QUOTE: '/exchanger-core/wallets/v3/conversion/quote',
  CONVERSION: '/exchanger-core/wallets/v3/conversion',
  CONVERSIONS_LIST: '/exchanger-core/wallets/v1/conversions',
  TRANSFER: '/exchanger-core/wallets/v3/transfer',
  CONVERT_UTA: '/exchanger-core/wallets/universal/convert',

  // activity info
  ACTIVITY_COMPETITION_INFO: '/phemex-activity/public/data/competition/info',
  ACTIVITY_COMPETITION_CREATE_TEAM: '/phemex-activity/competition/teams/create',
  ACTIVITY_COMPETITION_JOIN: '/phemex-activity/competition/members/join',
  ACTIVITY_COMPETITION_INDIVIDUAL_RANK: '/phemex-activity/public/data/competition/members/sort',
  ACTIVITY_COMPETITION_TEAM_DETAIL: '/phemex-activity/public/data/competition/team',
  ACTIVITY_COMPETITION_TEAM_RANK: '/phemex-activity/public/md/competition/teams/list/sort',
  ACTIVITY_COMPETITION_SELF: '/phemex-activity/competition/members/self',

  // cross-site-transfer
  CROSS_SITE_TRANSFER_SUPPORTED_CURRENCIES: '/exchanger-core/cross-site-transfer/supported-currencies',
  CROSS_SITE_TRANSFER_OUT: '/exchanger-core/cross-site-transfer/transfer-out',
  CROSS_SITE_CONNECTION_USER: '/phemex-user/cross-site/connection-user',
  CROSS_SITE_QUICK_REGISTER: '/phemex-user/users/cross-site/quick-register',
  CROSS_SITE_USERS_CONFIRM_LOGIN: '/phemex-user/users/cross-site/confirm/login',
  CROSS_SITE_USER_SIGNUP: '/phemex-user/users/cross-site/register',

  // kyc抽奖
  KYC_LOTTERY_PRIZE_POOL: '/phemex-activity/public/data/kyc-lottery/prizes',
  KYC_LOTTERY_INFO: '/phemex-activity/public/data/kyc-lottery/activity-info',
  KYC_LOTTERY_DRAW: '/phemex-activity/kyc-lottery/lottery',
  KYC_LOTTERY_CLAIM: '/phemex-activity/kyc-lottery/claim',
  KYC_LOTTERY_CLAIM_RECORDS: '/phemex-activity/kyc-lottery/claim-record',
  KYC_LOTTERY_MY_TO_CLAIM_PRIZES: '/phemex-activity/kyc-lottery/my-prizes',
  KYC_LOTTERY_TODAY_DRAW_RECORDS: '/phemex-activity/kyc-lottery/lottery-record/list',
  KYC_LOTTERY_CHECK_CLAIM_DISCOUNT: '/phemex-activity/kyc-lottery/check-claim-contract-discount',
  USER_TAG: '/phemex-client-data/users/tag/query',

  //钓鱼码
  USERS_ANTI_PHISHING_CODE: '/phemex-user/users/fishCode',
  USERS_ANTI_PHISHING_CODE_SUBMIT: '/phemex-user/users/fishCode/submit',

  // launchpool
  LAUNCHPOOL_PUBLIC_POOL: '/launchpool/public/pool',
  LAUNCHPOOL_PUBLIC_POOL_DETAIL: '/launchpool/public/pool/detail',
  LAUNCHPOOL_USER_POOL: '/launchpool/user/pool',
  LAUNCHPOOL_MYSELF_UNCLAIMED_REBATE: '/launchpool/user/unclaimed-rebate',
  LAUNCHPOOL_REBATE_CLAIM: '/launchpool/rebate/claim',
  LAUNCHPOOL_REBATE_STAT: '/launchpool/rebate/stat',
  LAUNCHPOOL_REBATE_LIST: '/launchpool/rebate/list',
  LAUNCHPOOL_REBATE_CLAIMED_LIST: '/launchpool/rebate/claimed-list',
  LAUNCHPOOL_PURCHASE: '/launchpool/purchase',
  LAUNCHPOOL_REDEMPTION: '/launchpool/redemption',
  LAUNCHPOOL_FUNDS: '/launchpool/funds',
  LAUNCHPOOL_POOL_DESC: '/launchpool/public/pool/desc',
  LAUNCHPOOL_REBATE_COUNTDOWN: '/launchpool/rebate/countdown',
  LAUNCHPOOL_USER_STAKING_QUOTA: '/launchpool/user/staking-quota',

  // 交易挖矿活动
  TRADE_MINING_INFO: '/phemex-activity/public/data/trade-mining/minings',
  TRADE_MINING_MISSION_LIST: '/phemex-activity/public/data/trade-mining/minings/missions',
  TRADE_MINING_USER_SCORE_INFO: '/phemex-activity/trade-mining/applications/scores',
  TRADE_MINING_USER_MISSION_INFO: '/phemex-activity/trade-mining/applications/missions',
  TRADE_MINING_APPLY: '/phemex-activity/trade-mining/applications',
  TRADE_MINING_UPLOAD_TWITTER_SCREENSHOT: '/phemex-activity/trade-mining/twitter-audit',

  // launchpad list
  // launchpad
  LAUNCHPAD_PROJECT_SUMMARY_PUBLIC: '/launchpad/public/data/project/summary',
  LAUNCHPAD_PROJECT_SUMMARY_LOGIN: '/launchpad/project/summary',
  LAUNCHPAD_PROJECT_LIST_PUBLIC: '/launchpad/public/data/groups',
  LAUNCHPAD_PROJECT_LIST_LOGIN: '/launchpad/groups',
  LAUNCHPAD_PROJECT_DETAIL_PUBLIC: '/launchpad/public/data/group/details',
  LAUNCHPAD_PROJECT_DETAIL_LOGIN: '/launchpad/group/details',
  LAUNCHPAD_PROJECT_ASSETS: '/launchpad/user/group-asset',
  LAUNCHPAD_PROJECT_SUBSCRIBE: '/launchpad/subscribe',
  LAUNCHPAD_PROJECT_REDEEM: '/launchpad/redeem',
  LAUNCHPAD_PROJECT_SUB_HISTORY: '/launchpad/user/sub-history',
  COIN_INFO_LIST: '/phemex-common-service/public/data/coin/info/list',

  // 翻币活动
  CLIP_COIN_ACTIVITY_INFO: '/phemex-activity/public/data/coin/activity/detail',
  CLIP_COIN_USER_ACTIVITY_APPLY_STATUS: '/phemex-activity/coin/activity/apply/status',
  CLIP_COIN_APPLY_ACTIVITY: '/phemex-activity/coin/activity/apply',
  CLIP_COIN_APPLY_ACTIVITY_RESULT: '/phemex-activity/coin/activity/apply/result',
  CLIP_COIN_ACTIVITY_APPLY_HISTORY: '/phemex-activity/coin/activity/apply/history',
  CLIP_COIN_CLAIM_REWARD: '/phemex-activity/coin/activity/claim',
  CLIP_COIN_ACTIVITY_RANK_LOGOUT: '/phemex-activity/public/data/coin/activity/rank',
  CLIP_COIN_ACTIVITY_RANK_LOGIN: '/phemex-activity/coin/activity/rank',
  CLIP_COIN_GET_BARRAGERS: '/phemex-activity/public/data/coin/activity/message',
  CLIP_COIN_SEND_BARRAGER: '/phemex-activity/coin/activity/message/submit',
  // 提供的指数的配置
  PRODUCTS_SCALE: '/public/index-products',
  INDEX_SOURCES: '/public/index-sources',

  //会员系统升级
  PREMIUM_PRIVILEGE_HISTORY_LIST: '/phemex/marketing/privilege/list',
  PREMIUM_LOTTERY: '/phemex/marketing/privilege/lottery',
  PREMIUM_QUALIFICATION_LIST: '/phemex/marketing/qualification/list',
  PREMIUM_PRIVILEGE_DETAILS: '/phemex/marketing/privilege/details',
  PREMIUM_PRIVILEGE_THIRDPRIVILEGEINFO: '/phemex/marketing/privilege/thirdPrivilegeInfo',
  PREMIUM_USER_MEMBER: '/phemex-user/users/member',
  PREMIUM_GROWTH_CONFIG: '/phemex-user/users/public/member/info/growth-config',
  MEMBER_IS_PREMIUM: '/phemex-user/users/member/is-premium',
  MEMBER_STAGE: '/phemex-user/users/public/member/stage',
  // 权益中心
  PREMIUM_PRIVILEGE_EXCHANEGE: '/phemex/marketing/privilege/exchange',

  // account/overview 费率调整
  SPOT_WALLET_ASSETS_TRADING_FEE_RATE: '/spot-wallet-assets/trading-fee-rate',
  PRIVACY_COIN: '/phemex-user/public/compliance/privacy/coin',
  PRODUCTS_COIN_INFO: '/phemex-common-service/public/data/coin/info',
  FAVORITE_LIST: '/phemex-user/users/favorites/list',
  ADD_FAVORITE: '/phemex-user/users/favorites',
  DEL_FAVORITE: '/phemex-user/users/favorites',
  CATEGORY_LIST: '/phemex-common-service/public/data/category/list',
  FAVORITES_MERGE: '/phemex-user/users/favorites/merge',
  COIN_BASIC: '/phemex-common-service/public/data/coin/basic',

  // earn-crypto 2.0
  EARN_CRYPTO_ACCOUNT_OVERVIEW: '/phemex-wm/account/v3',
  EARN_CRYPTO_RECOMMEND: '/phemex-wm/public/product/recommend',
  EARN_CRYPTO_PRODUCT_LIST: '/phemex-wm/public/product/v3/on-sale',
  EARN_CRYPTO_PRODUCT_LIST_NEW: '/phemex-wm/public/web/diversify-your-earnings',
  EARN_CRYPTO_PRODUCT_SELECT: '/phemex-wm/public/product/select',
  EARN_CRYPTO_AUTO_MATIC: '/phemex-wm/account/asset/config',
  EARN_CRYPTO_NEW_USER: '/phemex-wm/account/is-new-user',

  // my-earnings
  INVESTMENT_ACCOUNT_LIST: '/phemex-wm/account/v3',
  INVESTMENT_MY_EARNINGS_LIST: '/phemex-wm/wm-order/v2/active',
  INVESTMENT_ORDER_HISTORY_LIST: '/phemex-wm/wm-order/v2/history',
  INVESTMENT_SETTLEMENT_HISTORY_LIST: '/phemex-wm/wm-order/v2/settlement',
  INVESTMENT_TIMED_REDEMPTION: '/phemex-wm/wm-order/timed-redemption',
  // C2C
  C2C_CONFIG: '/phemex-uni-trade/public/data/config',
  C2C_ADVERTISE_UPDATE: '/phemex-uni-trade/delegate-order', // PUT 更新广告单
  C2C_ADVERTISE: '/phemex-uni-trade/delegate-order',
  C2C_ADVERTISE_MAKER_LIST: '/phemex-uni-trade/delegate-order/maker-list',
  C2C_ADVERTISE_STATUS: '/phemex-uni-trade/delegate-order/status',
  C2C_QUERY_ORDERS: '/phemex-uni-trade/order',
  C2C_QUERY_ALL_ORDERS: '/phemex-uni-trade/order/status-mutually-exclusive',
  C2C_QUERY_AD_DETAIL: '/phemex-uni-trade/delegate-order/detail',
  C2C_CAROUSEL: '/phemex-uni-trade/banner/p2p-banner-list/query',
  // C2C market
  C2C_QUERY_TRADING_ADS: '/phemex-uni-trade/delegate-order/public/trading-ad-list', // 可交易广告单查询
  C2C_QUERY_MAKER_TRADING_ADS: '/phemex-uni-trade/delegate-order/public/maker-trading-ad-list', // maker广告单列表查询
  C2C_QUERY_MAKER_FEATURE: '/phemex-uni-trade/delegate-order/public/maker-feature', // maker交易特征信息查询
  C2C_QUERY_USER_DEFAULT_BEHAVIOR: '/phemex-uni-trade/delegate-order/public/user-default-behavior', // 查询用户默认信息
  C2C_QUERY_USER_FEATURE: '/phemex-uni-trade/delegate-order/maker-feature',
  // C2C order
  C2C_CREATE_ORDER: '/phemex-uni-trade/order', // POST 创建C2C交易订单
  C2C_ORDER_DETAIL_BY_ID: '/phemex-uni-trade/order/id', // GET 订单详情
  C2C_ORDER_PAYMENT_METHOD: '/phemex-uni-trade/order/payment-method', // 按照订单ID查询卖家收款方式
  C2C_CANCEL_ORDER: '/phemex-uni-trade/order/cancel', // PUT 取消C2C订单
  C2C_ORDER_SELLER_CONFIRM: '/phemex-uni-trade/order/transfer/confirm', // GET 放款确认
  C2C_ORDER_BUYER_CONFIRM: '/phemex-uni-trade/order/payment/confirm', // GET 付款确认
  C2C_ORDER_COMMENT: '/phemex-uni-trade/order/comment', // POST 订单评价
  C2C_ORDER_APPEAL: '/phemex-uni-trade/order/appeal', // POST 订单申诉
  C2C_QUERY_FAST_ADVERTISE: '/phemex-uni-trade/delegate-order/match-list', // GET taker不同支付方式最优报价查询
  C2C_QUERY_PRICE_BY_CRYPTO: '/phemex-uni-trade/pricing/public/digital-fiat', // GET 通过数字币、法币查询数字币对应的法币价格
  C2C_ORDER_APPEAL_PROVE: '/phemex-uni-trade/order/appeal/prove', // 追加申诉
  C2C_ORDER_APPEAL_DELETE: '/phemex-uni-trade/order/appeal', // 撤销申诉
  C2C_ORDER_APPEAL_WORKFLOW: '/phemex-uni-trade/order/appeal/work-flow', // 申诉日志
  C2C_CANCEL_ORDER_CS: '/phemex-uni-trade/order/cancel-by-applicant', // 通过客服开启的按钮取消订单
  C2C_ORDER_APPEAL_DETAIL: '/phemex-uni-trade/order/appeal/detail', //查询订单当前的申诉详情
  C2C_QUERY_BEST_PRICE: '/phemex-uni-trade/pricing/public/delegate-order/best-price', //广告单最优市价

  // user payment method
  C2C_QUERY_USER_PAYMENT_METHODS: '/phemex-merchant-app/user/payment-method/query', // GET 查询用户支付方式
  C2C_CREATE_PAYMENT_METHOD: '/phemex-merchant-app/user/payment-method/add', // POST   新增用户支付方式
  C2C_UPDATE_PAYMENT_METHOD: '/phemex-merchant-app/user/payment-method/update', // PUT 更新用户支付方式
  C2C_DELETE_PAYMENT_METHOD: '/phemex-merchant-app/user/payment-method/delete', // PUT 删除用户支付方式
  C2C_QUERY_METHOD_TEMPLATE: '/phemex-merchant-app/c2c/merchant/query-payment-templates', // GET 根据条件查询平台配置的支付方式
  C2C_QUERY_METHOD_TEMPLATE_PUBLIC: '/phemex-merchant-app/c2c/merchant/public/query-payment-templates', // GET 根据条件查询平台配置的支付方式(public)
  // C2C USER
  C2C_QUERY_PERMISSION: '/phemex-merchant-app/c2c/query-permission', //查询maker/taker权限
  C2C_TO_MAKER_COMMENT: '/phemex-uni-trade/order/public/comment/maker-list', // 对maker的订单评价列表
  C2C_TO_USER_COMMENT: '/phemex-uni-trade/order/comment/maker-list', // 当前用户被评价列表接口
  C2C_COMMENT_MAKER_LIST: '/phemex-unitrade-core/order/comment/maker-list', //maker被评价列表接口

  // C2C IM
  C2C_IM_CHAT_CHANNEL: '/phemex-uni-trade/c2c/im/chat/channel', // GET 查询聊天室channel信息
  C2C_IM_NOTIFY_CHANNEL: '/phemex-uni-trade/c2c/im/notify/channel', // 查询系统通知channel信息
  //预言家活动
  PREDICT_ACTIVITY_INFO: '/phemex-activity/public/data/prophecy/activity/config/query',
  PREDICT_ACTIVITY_BET: '/phemex-activity/prophecy/activity/record/add',
  PREDICT_ACTIVITY_USER_TODAY_RECORDS: '/phemex-activity/prophecy/activity/record/query',
  PREDICT_ACTIVITY_USER_RECORDS: '/phemex-activity/prophecy/activity/my/record/query',
  PREDICT_ACTIVITY_NOTIFICATIONS: '/phemex-activity/public/md/prophecy/activity/record/mask',
  //推送更新 deviceId
  PUSH_DEVICE_UPDATE: '/phemex-activity/push-device/public/update',

  // fees-condiction 手續費調整
  SPOT_FEE_CONFIG: '/phemex-account/public/data/users/fee-config',
  SPOT_PROFILE: '/phemex-account/users/vip/profile',
  USER_MEMBER_LEVEL: '/phemex-account/users/member/level',

  // CFG_PRODUCTS: '/phemex-user/public/cfg/v2/products',

  //dashboard
  DASHBOARD_SUMMARY: '/phemex-kol-global/agent/dashboard/summary',
  DASHBOARD_REGISTER: '/phemex-kol-global/agent/dashboard/register',
  DASHBOARD_TUNNEL: '/phemex-kol-global/agent/dashboard/tunnel',
  DASHBOARD_TREND_CLIENT: '/phemex-kol-global/agent/dashboard/trend/client',
  DASHBOARD_TREND_AGENT: '/phemex-kol-global/agent/dashboard/trend/agent',
  DASHBOARD_TREND_TRADE: '/phemex-kol-global/agent/dashboard/trend/trade',
  DASHBOARD_TREND_REGISTER: '/phemex-kol-global/agent/dashboard/trend/register',
  DASHBOARD_TREND_MEMBERSHIP: '/phemex-kol-global/agent/dashboard/trend/membership',

  //commission details
  REBATE_DETAIL_LIST: '/phemex-kol-global/agent/commission/list',
  MEMBER_REBATE_LIST: '/phemex-kol-global/agent/commission/membership',
  USER_DETAIL_LIST: '/phemex-kol-global/agent/commission/userDetail',
  REBATE_RECORD_LIST: '/phemex-kol-global/agent/commission/recordDetail',
  AGENT_DETAIL_LIST: '/phemex-kol-global/agent/commission/agentDetail',
  AGENT_COMMISSION_RATE: '/phemex-kol-global/agent/commission/rule',

  //campaign
  ADD_GROUP: '/phemex-kol-global/agent/group/add',
  GROUP_LIST: '/phemex-kol-global/agent/group/list',
  GROUP_STATUS: '/phemex-kol-global/agent/group/status',
  USER_PROFILE: '/phemex-kol-global/agent/userProfile',

  //material
  SHORT_URL_LIST: '/phemex-kol-global/agent/shortUrl/list',
  SHORT_URL_CREATE: '/phemex-kol-global/agent/shortUrl/create',
  SHORT_URL_DELETE: '/phemex-kol-global/agent/shortUrl/delete',
  SHORT_URL_DETAIL: '/phemex-kol-global/agent/shortUrl/detail',

  //general
  BD_INFO: '/phemex-kol-global/agent/bdInfo',
  ALL_GROUP: '/phemex-kol-global/agent/allGroup',
  ALL_CURRENCY: '/phemex-kol-global/agent/allCurrency',

  //account wallet
  AGENT_INFO: '/phemex-kol-global/agent/info',
  BALANCE: '/phemex-kol-global/agent/wallet/balance',
  WALLET_SUMMARY: '/phemex-kol-global/agent/wallet/summary',
  WITHDRAW_ALL: '/phemex-kol-global/agent/wallet/withdraw/all',
  WALLET_RECORD_LIST: '/phemex-kol-global/agent/wallet/record/list',
  WITHDRAW: '/phemex-kol-global/agent/wallet/withdraw',
  AGENT_CASHBACK_RATE: '/phemex-kol-global/agent/group/cashback',

  //meme
  MEME_SYMBOLS: '/phemex-kol-global/meme/symbol/list',
  MEME_CURRENCIES: '/phemex-kol-global/meme/currency/list',

  // copy-trading common
  FOLLOW_TRADER: '/phemex-lb/user/follow',
  UNFOLLOW_TRADER: '/phemex-lb/user/unfollow',
  ME_SETTING: '/phemex-lb/user/preferences',
  TRADER_AVAILABLE_AVATARS: '/phemex-lb/user/avatars',
  USER_PNL_CHART: '/phemex-lb/public/data/user/pnl-chart',
  USER_PNL_RATE_CHART: '/phemex-lb/public/data/user/pnl-rate-chart',
  MY_FOLLOW_TRADERS: '/phemex-lb/v3/user/following',
  RECOMMEND_TRADERS: '/phemex-lb/public/data/v3/user/recommend',
  USER_RECOMMEND_TRADERS: '/phemex-lb/v3/user/recommend',
  TRADER_APPLICATION: '/phemex-lb/user/application',
  COPY_TRADE_ANNOUNCEMENT: '/phemex-lb/public/data/announcement',
  COPY_TRADE_SYS_CONFIG: '/phemex-lb/public/data/v3/sys/config',
  COPY_TRADE_TRANSFER_CURRENCIES: '/exchanger-core/public/data/copy-trade/transfer/currencies',
  // copy-trading follower-view
  CT_FOLLOWER_DETAIL: '/phemex-lb/v3/user',
  CT_FOLLOWER_POSITION_CURRENT: '/phemex-lb/public/data/position/current/v2',
  CT_FOLLOWER_POSITION_CURRENT_DETAIL: '/phemex-lb/public/data/position/operations/v2',
  CT_FOLLOWER_POSITION_HISTORY: '/phemex-lb/public/data/position/closed/v2',
  CT_FOLLOWER_POSITION_HISTORY_DETAIL: '/phemex-lb/public/data/position/operations/v2',
  // copy-trading copier-view
  CT_COPIER_ACCOUNT: '/phemex-lb/copier/v3/account',
  CT_COPIER_ADD_INVESTMENT: '/phemex-lb/copier/v3/investment/add',
  CT_COPIER_POSITION_CLOSED: '/phemex-lb/copier/position/closed/v2',
  CT_COPIER_POSITION_CURRENT: '/phemex-lb/copier/position/current/v2',
  CT_COPIER_MY_TRADER: '/phemex-lb/copier/v3/my-traders',
  CT_COPIER_UNCOPY: '/phemex-lb/user/uncopy',
  CT_COPIER_CLOSEPOSITION: '/phemex-lb/copier/close-copy-position',
  // copy-trading trader-view
  CT_TRADER_DETAIL: '/phemex-lb/v3/user/me',
  CT_TRADER_MY_COPIER: '/phemex-lb/trader/v3/my-copier/list',
  CT_TRADER_MY_COPIER_UNCOPY: '/phemex-lb/trader/uncopy',
  CT_TRADER_MY_COPIER_PROFIT: '/phemex-lb/trader/v3/my-profit/list',
  CT_TRADER_SETTINGS: '/phemex-lb/trader/v3/setting',
  CT_TRADER_EXIT: '/phemex-lb/trader/withdraw',
  CT_TRADER_POSITION_CURRENT: '/phemex-lb/position/my/current/v2',
  CT_TRADER_POSITION_CURRENT_DETAIL: '/phemex-lb/position/my/operations/v2',
  CT_TRADER_POSITION_HISTORY: '/phemex-lb/position/my/closed/v2',
  CT_TRADER_POSITION_HISTORY_DETAIL: '/phemex-lb/position/my/operations/v2',
  TRADER_DETAIL_PUBLIC: '/phemex-lb/public/data/v3/user',
  TRADER_INFO_PUBLIC: '/phemex-lb/public/data/v3/user/info',
  USER_TRADER_PROFILE: '/phemex-user/public/users/profile-list',
  COPY_TRADE_ACCOUNT_TRANSFER: '/exchanger-core/wallets/account/transfer',
  COPY_TRADE_COPIER_SETTINGS: '/phemex-lb/copier/v3/setting',
  ALTER_MESSAGE_STATUS: '/phemex-lb/copier/alert-message',
  TRADER_COPYING_SYMBOLS: '/phemex-lb/trader/copying-symbols',
  // copy-trading leaderborder
  COPY_TRADE_MY_RANKING: '/phemex-lb/trader/my-ranking',
  COPY_TRADE_USER_LEADERS: '/phemex-lb/public/data/user/leaders',
  // copy-trading draw
  CT_ACTIVITY_TASK_STATUS: '/phemex-lb/activity/2022-oct-tasks',
  CT_ACTIVITY_PARTICIPATION_LIST: '/phemex/marketing/public/md/scroll-privilege',
  CT_ACTIVITY_PRIVILEGE_LIST: '/phemex/marketing/privilege/condition/list',
  CT_ACTIVITY_SHARE: '/phemex-lb/activity/share',

  // copy-trading commentary
  CT_COMMENTARY_UNREAD: '/phemex-lb-community/post/unread',
  CT_COMMENTARY_LIST: '/phemex-lb-community/post/list',
  CT_COMMENTARY_PUBLISH: '/phemex-lb-community/post/publish',
  CT_COMMENTARY_DELETE: '/phemex-lb-community/post/delete',
  CT_COMMENTARY_OPINION: '/phemex-lb-community/post/opinion',
  CT_COMMENTARY_TRANSLATE: '/phemex-lb-community/post/translate',
  CT_COMMENTARY_IMG_UPLOAD: '/phemex-lb-community/file/post/img/upload',
  CT_CHECK_COPIER_RESTRICTION: '/phemex-lb/copier/check',

  CHANNEL_BANK_CARD: '/phemex-uni-trade/channel/bank-card',

  // copy-trading gmx
  GMX_RECOMMEND_TRADERS: '/phemex-lb/public/data/user/gmx/recommend',
  GMX_USER_RECOMMEND_TRADERS: '/phemex-lb/user/gmx/recommend',
  GMX_FOLLOWER_POSITION_HISTORY: '/phemex-lb/public/data/position/gmx/closed',
  GMX_FOLLOWER_POSITION_CURRENT: '/phemex-lb/public/data/position/gmx/current',
  GMX_FOLLOWER_POSITION_CURRENT_DETAIL: '/phemex-lb/public/data/position/gmx/operations',
  GMX_FOLLOWER_POSITION_HISTORY_DETAIL: '/phemex-lb/public/data/position/gmx/operations',

  //KOL 专属活动
  KOL_EXCLUSIVE_ACTIVITY_INFO: '/phemex-activity/public/data/kol/exclusive/activity-info',
  KOL_EXCLUSIVE_ACTIVITY_CLAIM: '/phemex-activity/kol/exclusive/claim',
  KOL_EXCLUSIVE_ACTIVITY_USER_INFO: '/phemex-activity/kol/exclusive/user-info',

  //KOL 专属落地页
  KOL_LANDING_PAGE_EXIST: '/phemex-activity/public/data/kol/page/exclusive',

  //assets flexible auto transfer
  ACCOUNT_ASSET_CONFIG: '/phemex-wm/account/asset/config',

  // vip program
  VIP_CONTRACT_INFO: '/phemex-activity/vip/contract/info',
  VIP_RATIO_CONFIG: '/phemex-account/public/data/users/level-ratio-config',

  // official verification
  OFFICIAL_VERIFY: '/phemex-account/public/data/users/official/verify',

  // SWAP
  SWAP_CONFIG: '/exchanger-core/public/data/swap/config',
  SWAP_CREATE: '/exchanger-core/wallets/spot/swap',
  SWAP_HISTORY: '/exchanger-core/wallets/spot/swap',

  //预测产品
  PREDICT_TOPIC_CATEGORY: '/phemex-predict/public/data/topic/category',
  PREDICT_TOPICS: '/phemex-predict/public/topic',
  PREDICT_TOPICS_BUY: '/phemex-predict/order/buy',
  PREDICT_KYC_CHECK: '/phemex-predict/account/kyc/check',
  PREDICT_MESSAGE: '/phemex-predict/public/data/predict/message',
  ACCOUNT_SHARES: '/phemex-predict/account/shares',
  ACCOUNT_ASSETS: '/phemex-predict/account/assets',
  ACCOUNT_POSITION: '/phemex-predict/account/position',
  ORDER_HISTORY: '/phemex-predict/order/history',
  ORDER_REDEEM: '/phemex-predict/order/redeem',
  PREDICT_SUCCESS_COUNT: '/phemex-predict/account/success-topic-count',
  // 灰度查询
  COMMON_ABTEST: '/phemex-common-service/abtest',

  CUSTOMIZE_ACTIVITY_INFO: '/phemex-activity/public/data/campaign/info',
  CUSTOMIZE_ACTIVITY_SIGN_UP: '/phemex-activity/campaign/sign-up',
  CUSTOMIZE_ACTIVITY_SUBSCRBE: '/phemex-activity/public/data/campaign/submit',

  // 理财落地页
  COUPON_DETAIL: '/phemex/marketing/public/md/exchange/code/query/detail',
  COUPON_PRIVILEGE: '/phemex/marketing/privilege/condition/list',
  COUPON_EXCHANGE: '/phemex/marketing/privilege/exchange',
  // 查询用户twitter提交信息
  WELCOME_BONUS_MEDIA_RECORDS: '/phemex-activity/bonus/twitter-process-status',
  // welcome bonus 数额
  WELCOME_BONUS_AMOUNT: '/phemex-activity/public/data/welcome/detail',
  // welcome bonus 数额
  WELCOME_BONUS_USER_CREATE_TIME: '/phemex-user/users/self',

  WEB_RECOMMEND: '/phemex-predict/public/data/web/recommend',
  ROTATION_BAR: '/phemex-predict/public/md/web/rotation-bar',
  KOL_INFO: '/phemex-predict/public/data/kol-name',

  // referral
  REFERRAL_LINK_PAGE: '/phemex-activity/activity/referral/link/page',
  REFERRAL_REWARD_PAGE: '/phemex-activity/activity/referral/reward/page',
  REFERRAL_REWARD_SUMMARY: '/phemex-activity/activity/referral/reward/summary',

  REFERRAL_CONFIG: '/phemex-activity/public/data/referral/config',
  REFERRAL_EARNING: '/phemex-activity/activity/referral/reward/monthSummary',
  REFERRAL_HISTORY: '/phemex-activity/activity/referral/link/page',
  REFERRAL_DEPOSIT_STATUS: '/phemex-activity/activity/referral/status',
  REFERRAL_KYC: '/phemex-kyc/kyc/summary-all',
  // 查询出金地址是否存在
  ADDRESS_EXIST: '/phemex-withdraw/wallets/app/address-exist',

  // price page
  GET_COIN_LIST: '/phemex-activity/public/md/query/coin-list',

  //kevin
  CAMPAIGN_INCREMENT_ANDGET: '/phemex-activity/public/data/campaign/incrementAndGet',
  ACTIVITY_USER_INFO: '/phemex-activity/activity/user/info',
  // hot spot , hot contracts
  HOT_SPOT_CONTRACT: '/phemex-activity/public/data/hot/symbol/config',

  // kol
  VIP_ASSETS: '/phemex-kol-global/vip/asset',
  VIP_HISTORY: '/phemex-kol-global/vip/asset/history',
  VIP_TRANSACTIONS: '/phemex-kol-global/vip/transaction',
  VIP_ALL_TRANSACTIONS: '/phemex-kol-global/vip/all-transaction',
  VIP_CONTRACT_SUMMARY: '/phemex-kol-global/vip/contract/summary',
  VIP_CONTRACT_TOTAL: '/phemex-kol-global/vip/contract/total',
  VIP_CONTRACT_PAIRS: '/phemex-kol-global/vip/contract/trading-symbol',
  VIP_MANAGER_EMAIL: '/phemex-kol-global/vip/info',
  VIP_TRADE_SYMBOLS: '/phemex-kol-global/vip/symbol',
  VIP_ASSETS_DOWNLOAD_DATA: '/phemex-kol-global/vip/asset/detail',
  VIP_CONTRACT_DOWNLOAD_DATA: '/phemex-kol-global/vip/contract/detail',
  // 用户年度报告
  ANNUAL_DATA: '/contract-biz/period-report/annual/data',
  ANNUAL_RANK: '/contract-biz/period-report/annual/rank',

  ACTIVITY_REWARDS: '/activity/rewards',

  // margin trade
  MT_BORROW_INTERESTS_HISTORY: '/margin/borrow/interests',
  MT_FUNDS_HISTORY: '/margin/funds',
  MT_BORROW: '/margin/borrow',
  MT_REPAY: '/margin/payback',
  MT_BORROW_HISTORY: '/margin/borrow',
  MT_REPAY_HISTORY: '/margin/payback',
  MT_ORDER_HISTORY: '/margin/orders',
  MT_TRADE_HISTORY: '/margin/orders/trades',
  MT_TRADE_LIMIT: '/phemex-assets-mgmt/margin_trade_config/public/list',
  MARGIN_SYS_REMAINING_BORROW: '/margin-trade/wallets/query-firm-account',
  MARGIN_SYS_REMAINING_BORROW_UTA: '/uta/margin-trade/wallets/query-firm-account',
  COMMON_GRAY: '/phemex-user/biz-gray', // 灰度接口
  MT_WALLETS: '/margin/query-wallets',

  // web3
  WEB3_SOUL_PASS_OVERVIEW: '/phemex-account/soul-pass/overview', // 查询 soul-pass 信息
  WEB3_MINT: '/phemex-account/soul-pass/mint', // 铸币
  WEB3_REVOKE: '/phemex-account/soul-pass/revoke', // 重铸
  WEB3_ADDRESSES_CREATE: '/phemex-account/soul-pass/wallets/create', // 创建一个SBT soul pass的地址
  WEB3_ADDRESSES_BIND: '/phemex-account/soul-pass/wallets/bind', // 绑定 web3 钱包地址
  WEB3_ADDRESSES_UNBIND: '/phemex-account/soul-pass/wallets/unbind', // 解除绑定 web3 钱包地址
  WEB3_MNEMONIC: '/phemex-account/soul-pass/mnemonic', // 获取用户助记词
  WEB3_SOUL_PASS_STATUS: '/phemex-account/soul-pass/status', // 获取用户 Soul-Pass 状态数据
  SPOT_EQUITY_ASSET_HISTORY: '/phemex-user/wallets/spot/equity/detail', // phemex EQUITY 币现货资产流水
  SPOT_EQUITY_ASSET_HISTORY_UTA: '/margin/equity/detail', // phemex EQUITY 币现货资产流水
  WEB3_SOUL_PASS_MINT_QUALIFY: '/phemex-account/soul-pass/qualifications', // 查看用户是否满足Mint的条件(满足任一条件)
  WEB3_SBT_LIST: '/phemex-account/account/sbt/sbt-meta-all', // 查询所有类型的sbt，并且如果用户已获取，会返回用户获取的情况
  WEB3_GENERAL_START: '/phemex-user/public/users/web3/general-start',
  WEB3_WALLET_LOGIN: '/phemex-user/users/web3/wallet-login',
  WEB3_BIND_WALLET: '/phemex-user/users/web3/bind-wallet',
  WEB3_PRE_BIND_EMAIL: '/phemex-user/users/pre-bind-email',
  WEB3_BIND_EMAIL: '/phemex-user/users/bind-email',
  WEB3_CRYPTO_LIST: '/phemex-account/web3/assets',
  WEB3_NFT_LIST: '/phemex-account/web3/nft',
  WEB3_INFO: '/phemex-account/web3/query',
  WEB3_100ETH_INFO: '/phemex-activity/public/cfg/100eth/info', // 100ETH活动信息
  WEB3_100ETH_USER: '/phemex-activity/public/data/100eth/users', // 100ETH活动用户
  WEB3_100ETH_WINNERS: '/phemex-activity/public/data/100eth/winners', // 100ETH活动中奖用户
  WEB3_SUPPORT_CHAINS: '/phemex-account/public/data/users/web3/chain-name',
  WEB3_1000BTC_GROUP: '/phemex-activity/public/md/vote/btc/group',
  WEB3_1000BTC_LIST: '/phemex-activity/vote/btc/list',
  WEB3_1000BTC_VOTE: '/phemex-activity/vote/btc',
  WEB3_1000BTC_PARTICIPANT: '/phemex-activity/public/scroll/participant/list',
  WEB3_1000BTC_GROUP_LOGIN: '/phemex-activity/public/md/vote/btc/group',
  WEB3_1000BTC_PRICE: '/phemex-activity/public/md/vote/btc/price',
  WEB3_STAKE_PUBLIC_DATA_PROJECTS: '/phemex-stake/public/data/projects', // 查询stake项目_public
  WEB3_STAKE_OVERVIEW_PUBLIC: '/phemex-stake/public/data/overview', // 主页overview public
  WEB3_STAKE_OVERVIEW: '/phemex-stake/overview', // 主页overview
  WEB3_STAKE_REDEEM: '/phemex-stake/redeem', // 赎回
  WEB3_STAKE_STAKE: '/phemex-stake/stake', // 质押
  WEB3_STAKE_REWARDS_CLAIM: '/phemex-stake/rewards/claim', // 领取收益
  WEB3_STAKE_REWARDS_AUTO_COMPOUND: '/phemex-stake/rewards/auto-compound', // 收益自动复投
  WEB3_STAKE_VESTING_PLAN: '/phemex-stake/vesting/plan', // 线性释放计划查询
  WEB3_STAKE_VESTING_PLAN_DETAIL: '/phemex-stake/vesting/plan/detail', // 线性释放计划明细查询
  WEB3_STAKE_REDEEM_HISTORY: '/phemex-stake/redeem', // 赎回历史
  WEB3_STAKE_STAKE_HISTORY: '/phemex-stake/stake', // 质押历史查询
  WEB3_STAKE_REWARDS_CLAIM_HISTORY: '/phemex-stake/rewards/claim', // 收益领取历史
  WEB3_STAKE_BUYBACK_HISTORY: '/phemex-stake/public/data/buyback', // 回购历史
  // PT销毁
  WEB3_STAKE_BURN_MONTH: '/phemex-stake/public/burn/month', // PT月度销毁数据
  WEB3_STAKE_BURN_DETAIL: '/phemex-stake/public/burn/detail', // PT销毁详细数据
  WEB3_STAKE_BURN_STATS: '/phemex-stake/public/burn/stats', // PT销毁统计数据
  WEB3_STAKE_REWARDS_APR_HISTORY: '/phemex-stake/public/data/rewards/apr', // APR历史记录
  WEB3_PT_MINING_PUBLIC_MINING_POOL: '/phemex-pt-mining-app/public/data/mining/pool', // 查询当日奖池信息(公共)
  WEB3_PT_MINING_AWARD_RECORD: '/phemex-pt-mining-app/award/query', // 查询用户奖励历史
  WEB3_PT_MINING_MINING_USER: '/phemex-pt-mining-app/mining/user', // 查询参与用户信息
  WEB3_PT_MINING_AWARD_BOOST: '/phemex-pt-mining-app/award/boost', // 查询用户最新的Boost
  WEB3_PT_MINING_AWARD_TYPE_UPDATE: '/phemex-pt-mining-app/award/type/update', // 修改用户建立发放配置
  WEB3_PT_MINING_MONTH_STATISTIC: '/phemex-pt-mining-app/month/statistic', // 查询用户按月统计数据
  WEB3_PT_MINING_AWARD_BOOST_CALCULATE: '/phemex-pt-mining-app/award/boost/calculate', // 估算boost系数
  AUCTION_REDEEM: '/launchpad/auction/redeem', // 荷兰拍赎回
  AUCTION_BALANCE: '/launchpad/auction/balance', // 荷兰拍查询用户拍卖余额
  AUCTION_COMMIT: '/launchpad/auction/commit', // 荷兰拍竞拍
  AUCTION_PROJECTS_PT: '/launchpad/auction/public/md/projects/pt', // 荷兰拍 查询PT拍卖信息
  // social trade
  WEB3_SOCIAL_PRIZE_POOL: '/phemex-activity/public/cfg/social/reward/pool',
  WEB3_SOCIAL_MY_TRADE_GROUPS: '/phemex-activity/social/user/group',
  WEB3_SOCIAL_MY_INFO: '/phemex-activity/social/user/info',
  WEB3_SOCIAL_TRADE_GROUPS: '/phemex-activity/public/data/social/v1/group/list',
  WEB3_SOCIAL_RAFFLE_CONFIGS: '/phemex-activity/public/data/social/raffle/config',
  WEB3_SOCIAL_RAFFLE_CONFIGS_: '/phemex-activity/public/data/social/raffle/config',
  WEB3_SOCIAL_TRADE_GROUPS_LOGIN: '/phemex-activity/social/v1/group/list',
  WEB3_SOCIAL_TRADE_GROUP_LEADER_BOARD: '/phemex-activity/public/data/social/group/board',
  WEB3_SOCIAL_TRADE_GROUP_LEADER_BOARD_LOGIN: '/phemex-activity/social/group/board',
  WEB3_SOCIAL_CREATE_GROUP: '/phemex-uni-trade/group/im/create/group/v2',
  WEB3_SOCIAL_JOIN_GROUP: '/phemex-uni-trade/group/im/direct/join/group',
  WEB3_SOCIAL_INVITE_JOIN_GROUP: '/phemex-uni-trade/group/im/join/group',
  WEB3_SOCIAL_INVITE_JOIN_GROUP_WITH_REFERRAL_CODE: '/phemex-uni-trade/group/im/join/group/by/referralCode',
  WEB3_SOCIAL_GROUP_INFO_WITH_EN_GROUP: '/phemex-uni-trade/public/data/group/im/group/profile/query',
  WEB3_SOCIAL_GROUP_INFO_WITH_REFERRAL_CODE: '/phemex-uni-trade/public/group/im/profile/query/by/referralCode',
  WEB3_SOCIAL_GROUP_INFO: '/phemex-activity/public/data/social/v1/group/detail',
  WEB3_SOCIAL_GROUP_INFO_LOGIN: '/phemex-activity/social/v1/group/detail',
  WEB3_SOCIAL_SHARE_LINKS: '/phemex-uni-trade/group/im/group/share/all-link',
  WEB3_SOCIAL_SHARE_INFO: '/phemex-uni-trade/group/im/group/share/info',
  WEB3_SOCIAL_SHARE_CAST: '/phemex-im-server/im/post/share/last-cast',
  WEB3_GROUP_DETAIL: '/phemex-activity/public/data/social/v1/group/detail',
  WEB3_GROUP_DETAIL_LOGIN: '/phemex-activity/social/v1/group/detail',

  IM_UPLOAD_IMAGE: '/phemex-im-server/im/post/s3/upload/image',

  ACCOUNT_VIP_PROFILE: '/phemex-account/users/vip/campaign/profile', // 用户vip信息查询
  ACCOUNT_VIP_LEVEL_CONFIG: '/phemex-account/public/data/users/simple/level-config', // vip等级配置
  ACCOUNT_BIZ_GRAY: '/phemex-account/biz-gray', // phemex-user-account-app通用灰度接口
  ACCOUNT_GENERAL_START: '/phemex-account/general/start', // phemex-user-account-app通用开启_start/confirm_模式接口
  // 查询Equity兑换总量
  KOL_COMMISSION_EQUITY_AMOUNT: '/phemex-kol-global/sbt/total',
  // 查询Equity兑换明细
  KOL_COMMISSION_EQUITY_DETAIL: '/phemex-kol-global/sbt/detail',
  // 查询Equity兑换的价格
  KOL_COMMISSION_EQUITY_PRICE: '/phemex-kol-global/sbt/currency',

  // KOL dashboard
  KOL_COMMISSION_SUMMARY: '/phemex-kol-global/dashboard/summary/commission',
  KOL_TRADE_SUMMARY: '/phemex-kol-global/dashboard/summary/trade',
  KOL_REFERRAL_SUMMARY: '/phemex-kol-global/dashboard/summary/referral',
  KOL_REFERRAL_TRADE_SUMMARY: '/phemex-kol-global/dashboard/summary/referral-trade',
  KOL_DASHBOARD_WALLET_SUMMARY: '/phemex-kol-global/dashboard/summary/wallet',
  KOL_DASHBOARD_EXPORT: '/phemex-kol-global/dashboard/summary/export',
  SHARE_PAGE_LIST: '/phemex-kol-global/agent/sharepage/list',
  KOL_DASHBOARD_XPT_DISTRIBUTION: '/phemex-kol-global/sbt/sum',
  KOL_DASHBOARD_VEPT_PHRASES: '/phemex-kol-global/public/agent/commission/vept',
  KOL_DASHBOARD_DEPOSIT_SUMMARY: '/phemex-kol-global/dashboard/summary/deposit',
  //KOL 专属落地页
  KOL_LANDING_PAGE_DETAIL: '/phemex-activity/kol/page/public/data/config-info',
  // KOL 活动配置
  KOL_ACTIVITY_CONFIG: '/phemex-activity/public/data/campaign/info',
  KOL_ACTIVITY_USER_INFO: '/phemex-activity/campaign/user-info',
  KOL_ACTIVITY_SIGN_UP: '/phemex-activity/campaign/sign-up',

  //sensor dialog
  INNER_DIALOG: '/phemex-activity/dialog/available/list',
  INNER_DIALOG_TESTING: '/phemex-activity/dialog/tester/list',

  // fiat-Account
  FIAT_BALANCE_QUERY: '/phemex-uni-trade/fiat/balance/query', //查询法币余额
  FIAT_DEPOSIT_ACCOUNT_QUERY: '/phemex-uni-trade/fiat/deposit/account/query', //查询入金账号
  FIAT_DEPOSIT_SUCCESS_CONFIRM: '/phemex-uni-trade/fiat/deposit-success/confirm', //同步用户打款完成
  FIAT_DEPOSIT_QUERY: '/phemex-uni-trade/fiat/deposit-order/query', //入金单据查询
  FIAT_DEPOSIT_WITHDRAW_QUERY_PUBLIC: '/phemex-uni-trade/public/md/fiat/withdraw/config', //出金配置
  FIAT_DEPOSIT_WITHDRAW_QUERY: '/phemex-uni-trade/fiat/withdraw/config/v2', //出金配置
  FIAT_DEPOSIT_WITHDRAW_CARDS: '/phemex-uni-trade/fiat/withdraw/cards', //卡列表
  FIAT_DEPOSIT_WITHDRAW_SUBMIT: '/phemex-uni-trade/fiat/withdraw/submit', //出金请求
  FIAT_WITHDRAW_ORDER_LIST: '/phemex-uni-trade/fiat/withdraw/order/query', //出金单据查询
  FIAT_BALANCE_CHANGE_QUERY: '/phemex-uni-trade/fiat/balance/change/query', //余额变更记录查询
  FIAT_ORDER_QUERY: '/phemex-uni-trade/fiat/order/query', //余额变更记录查询
  FIAT_DEPOSIT_ORDER_LIST: '/phemex-uni-trade/fiat/deposit/order/query', // 法币入金订单列表
  FIAT_DEPOSIT_CONFIRM: '/phemex-uni-trade/fiat/deposit/success/confirm', // 入金确认
  FIAT_BIZ_GARY: '/phemex-uni-trade/biz-gray', // 法币灰度
  FIAT_RISK_CHECK: '/phemex-uni-trade/fiat/risk/check',
  FIAT_WITHDRAW_BANK_ACCOUNT: '/phemex-uni-trade/fiat/withdraw/account/query',
  FIAT_WITHDRAW_BANK_ACCOUNT_ADD: '/phemex-uni-trade/fiat/withdraw/account/add',
  FIAT_WITHDRAW_BANK_ACCOUNT_REMOVE: '/phemex-uni-trade/fiat/withdraw/account/unbind',
  FIAT_WITHDRAW_BANK_COUNTRIES: '/phemex-uni-trade/fiat/withdraw/account/countries',
  FIAT_WITHDRAW_BANK_FIELDS: '/phemex-uni-trade/fiat/withdraw/account/fields',

  // one click buy/sell
  OC_CONFIG: '/phemex-uni-trade/one-click/config',
  OC_FIAT_ORDER: '/phemex-uni-trade/buy-crypto/fiat-balance/place-order',
  OC_BANK_CARD: '/phemex-uni-trade/channel/bank-card',
  OC_PLACE_ORDER: '/phemex-uni-trade/buy-crypto/b2c/place-order',
  OC_RISK_CHECK: '/phemex-uni-trade/buy-crypto/b2c/risk-check',
  OC_KYC_VALIDATE: '/phemex-uni-trade/buy-crypto/b2c/kyc-verify',
  OC_FIAT_BALANCE_HISTORY: '/phemex-uni-trade/buy-crypto/otc-trade-req/list',
  OC_CREDIT_DEBIT_CARD_HISTORY: '/phemex-uni-trade/buy-crypto/b2c/order/list',
  OC_DEFAULT_PAYMENT_METHOD: '/phemex-uni-trade/buy-crypto/last-trade',
  OC_CREDIT_DEBIT_BIND_CARD: '/phemex-uni-trade/channel/bank-card',
  OC_NEW_CARD_DETAIL: '/phemex-uni-trade/channel/bank-card',
  OC_THIRD_PARTY_HISTORY: '/phemex-uni-trade/third-party/orders',
  OC_TRANSAK_ORDER: '/phemex-uni-trade/buy-crypto/transak/place-order',
  OC_TRANSAK_SAVE_ORDER: '/phemex-uni-trade/buy-crypto/transak/outer-order-id-save',
  OC_TRANSAK_ORDER_LIST: '/phemex-uni-trade/buy-crypto/transak/bank-order/list',
  OC_FIAT_DEPOSIT_CONFIRM: '/phemex-uni-trade/fiat/event/receive/confirm',

  //xpt 活动
  XPT_MINING_INFO: '/phemex-activity/public/md/xpt-mining/info',
  XPT_MINING_USER_INFO: '/phemex-activity/xpt-mining/user-info',
  XPT_MINING_RANK_LIST: '/phemex-activity/public/md/xpt-mining/rank-page',
  XPT_SOUL_PASS_SUMMARY: '/phemex-account/public/data/users/soul-pass-summary',
  XPT_LEVEL_CONFIG: '/phemex-account/public/data/users/campaign/level-config',
  XPT_LEVEL_SIMPLE_CONFIG: '/phemex-account/public/data/users/simple/level-config',
  XPT_USER_LEVEL_CONFIG: '/phemex-account/users/vip/campaign/profile',

  //contract grid
  MARKETPLACE_SUMMARY: '/phemex-strategy/strategy/public/data/marketplace/summary',
  MARKETPLACE_DROPDOWN_INFO: '/phemex-strategy/strategy/public/data/marketplace/dropdown-info',
  MARKETPLACE_SEARCH: '/phemex-strategy/strategy/public/data/marketplace/search',
  STRATEGY_ORDER_LIST: '/phemex-strategy/strategy/detail-order-list',
  STRATEGY_ARBI_SUMMARY: '/phemex-strategy/strategy/detail-arbi-summary',
  STRATEGY_DETAIL_MAIN: '/phemex-strategy/strategy/detail-main',
  STRATEGY_UPDATE_TPSL: '/phemex-strategy/strategy/adjust-tpsl',
  STRATEGY_ARBI_LIST: '/phemex-strategy/strategy/detail-arbi-list',
  STRATEGY_ADD_BALANCE: '/phemex-strategy/strategy/increase-balance',
  STRATEGY_GRID_WITHDRAWABLE: '/phemex-strategy/strategy/grid/profit/withdrawable',
  STRATEGY_GRID_WITHDRAW: '/phemex-strategy/strategy/grid/profit/withdraw',
  STRATEGY_AIR_POS_LIST: '/phemex-strategy/airdrop-position/query',
  LEADER_INFO: '/phemex-kol-global/leader/info',

  // 返回contract/spot的网格数据
  STRATEGY_ALL_MY_OPEN: '/phemex-strategy/strategy/my/all-open',

  // contract martingale
  MARKETPLACE_MARTINGALE: '/phemex-strategy/strategy/public/data/martin/marketplace/search',
  MARTINGALE_DETAIL_MAIN: '/phemex-strategy/strategy/martin/detail-main',
  MARTINGALE_CYCLE_HISTORY_LIST: '/phemex-strategy/strategy/martin/cycle-history-list',
  MARTINGALE_DETAIL_ORDER_LIST: '/phemex-strategy/strategy/martin/detail-order-list',
  MARTINGALE_ADJUST_TP_SL: '/phemex-strategy/strategy/martin/adjust-tpsl',

  // Contract Signal
  SIGNAL_DETAIL_MAIN: '/phemex-strategy/strategy/signal/detail-main',
  SIGNAL_DETAIL_OPEN_POSITION: '/phemex-strategy/strategy/signal/detail-open-pos',
  SIGNAL_DETAIL_CLOSE_POSITION: '/phemex-strategy/strategy/signal/detail-close-pos',
  SIGNAL_DETAIL_ORDER_LIST: '/phemex-strategy/strategy/signal/detail-order-list',
  SIGNAL_DETAIL_ORDER_RECORD: '/phemex-strategy/strategy/signal/detail-signal-rec',
  SIGNAL_DETAIL_DECREASE_BALANCE: '/phemex-strategy/strategy/decrease-balance',
  SIGNAL_DETAIL_SETTINGS: '/phemex-strategy/signal/detail',

  // spot grid
  SPOT_MARKETPLACE_DROPDOWN_INFO: '/spot-strategy/strategy/public/data/marketplace/dropdown-info',
  SPOT_MARKETPLACE_SEARCH: '/spot-strategy/strategy/public/data/marketplace/search',
  SPOT_STRATEGY_DETAIL_MAIN: '/spot-strategy/strategy/detail-main',
  SPOT_STRATEGY_ORDER_LIST: '/spot-strategy/strategy/detail-order-list',
  SPOT_STRATEGY_ARBI_SUMMARY: '/spot-strategy/strategy/detail-arbi-summary',
  SPOT_STRATEGY_ARBI_LIST: '/spot-strategy/strategy/detail-arbi-list',
  SPOT_STRATEGY_UPDATE_TPSL: '/spot-strategy/strategy/adjust-tpsl',

  UPDATE_CUSTOMIZE: '/contract-biz/cfg/customize/update',
  QUERY_CUSTOMIZE: '/contract-biz/cfg/customize/query',

  // xpt airdrop 活动
  ACTIVITY_OPERATION_INFO: '/phemex-activity/public/md/operation/activity/info',
  ACTIVITY_OPERATION_SUBMIT_MATERIAL: '/phemex-activity/operation/task/submit/material',
  ACTIVITY_OPERATION_USER_TASK_LIST: '/phemex-activity/operation/task/list',
  ACTIVITY_QUERY_PRIZE_POOL_LOGIN: '/phemex/marketing/prize/pool/query',
  ACTIVITY_QUERY_PRIZE_POOL: '/phemex/marketing/public/md/prize/pool/query',
  ACTIVITY_CLAIM_PRIZE: '/phemex/marketing/privilege/lottery',
  ACTIVITY_SCROLL_PARTICIPANT: '/phemex-activity/public/md/operation/activity/participant/scroll',
  ACTIVITY_XPT_AIRDROP_GARY: '/phemex-activity/public/gray/info',

  //domain
  ADDRESS_DOMAIN_CONVERT: '/phemex-withdraw/wallets/app/address/domain/convert',

  //不用public
  BUY_CRYPTO_CONFIG: '/phemex-uni-trade/config/channels',
  BUY_CRYPTO_PRICING: '/phemex-uni-trade/buy-crypto/pricing/v2',

  //用public
  PUBLIC_BUY_CRYPTO_CONFIG: '/phemex-uni-trade/public/md/config/channels',
  PUBLIC_BUY_CRYPTO_PRICING: '/phemex-uni-trade/public/md/buy-crypto/pricing',
  PUBLIC_B2C_BANNER: '/phemex-withdraw/public/data/app/banner/query_list',
  PUBLIC_FIAT_DEPOSIT_CONFIG: '/phemex-uni-trade/public/md/fiat/deposit/config', //查询法币入金的配置

  //space id
  SPACE_ID_SUBMIT_WALLET_ADDRESS: '/phemex-activity/space/psp/submit',
  SPACE_ID_CLAIM_GIFTCARD: '/phemex-activity/space/psp/claim',
  SPACE_ID_CHECK_WALLET_ADDRESS: '/phemex-activity/space/psp/check-address',
  SPACE_ID_CHECK_CLAIM_STATUS: '/phemex-activity/space/psp/claim-status',
  SPACE_ID_GIFTCARD_COUNT: '/phemex-activity/space/psp/find-claim',
  SPACE_ID_PUBLIC_GIFTCARD_COUNT: '/phemex-activity/public/space/psp/find-claim',

  ACTIVITY_GARY: '/phemex-activity/public/gray/info',
  // 邀请页面与stage无关的数据
  ACTIVITY_REFERRAL_TOTAL_INFO: '/phemex-activity/referral/user/summary',
  // 邀请页面
  ACTIVITY_REFERRAL_INFO: '/phemex-activity/referral/user/detail/list',
  // 当前用户受邀类型
  ACTIVITY_REFERRAL_SELF_USER_TYPE: '/phemex-activity/referral/user/self/info',
  // 查询各个stage referral 奖励
  ACTIVITY_REFERRAL_STAGE_REWARDS: '/phemex-activity/public/data/referral/award-config',

  FUTURE_GRIDS_CONTEST_INFO: '/phemex-activity/public/data/competition/info',
  FUTURE_GRIDS_CONTEST_USER_INFO: '/phemex-activity/competition/members/self',
  FUTURE_GRIDS_CONTEST_JOIN: '/phemex-activity/competition/members/join',
  FUTURE_GRIDS_CONTEST_RANKING: '/phemex-activity/public/data/competition/members/sort',
  FUTURE_GRIDS_CONTEST_AWARD: '/phemex-activity/public/data/competition/award/page',
  FUTURE_GRIDS_CONTEST_SUMMARY: '/phemex-activity/competition/strategy/summary',
  FUTURE_GRIDS_CONTEST_TASK: '/phemex-activity/competition/strategy/v1/task',

  // 团赛
  TEAM_COMPETITION_INFO: '/phemex-activity/public/data/competition/info',
  TEAM_COMPETITION_USER_INFO: '/phemex-activity/competition/members/self',
  TEAM_COMPETITION_USERS: '/phemex-activity/competition/members/self',
  TEAM_COMPETITION_JOIN: '/phemex-activity/competition/members/join',
  TEAM_COMPETITION_RANKING: '/phemex-activity/public/data/competition/members/sort',
  TEAM_COMPETITION_RANKING_LOGIN: '/phemex-activity/competition/public/members/sort',
  TEAM_COMPETITION_AWARD: '/phemex-activity/public/data/competition/award/page',
  TEAM_COMPETITION_SUMMARY: '/phemex-activity/competition/strategy/summary',
  TEAM_COMPETITION_TASK: '/phemex-activity/competition/strategy/v1/task',
  TEAM_COMPETITION_TEAMS: '/phemex-activity/public/md/competition/teams/list/sort',
  TEAM_COMPETITION_TEAMS_LOGIN: '/phemex-activity/competition/teams/list/sort',
  TEAM_COMPETITION_CREATE_TEAM: '/phemex-activity/competition/teams/create',
  TEAM_COMPETITION_TEAM_INFO: '/phemex-activity/public/data/competition/team',
  TEAM_COMPETITION_INDIVIDUAL_RANKS: '/phemex-activity/competition/public/members/sort',
  TEAM_COMPETITION_LEAVE_TEAM: '/phemex-activity/competition/members/leave/team',
  TEAM_COMPETITION_MANAGE_TEAM: '/phemex-activity/competition/leader/manage/team',
  TEAM_COMPETITION_USE_NET_ASSET: '/phemex-activity/competition/members/accountNetWorth',

  // 用户资产
  USER_ASSETS_QUERY: '/phemex-account/users/assets/query',

  // 申请成为Broker
  BROKER_APPLY: '/phemex-kol-global/broker/apply',
  // Broker申请信息
  BROKER_APPLY_INFO: '/phemex-kol-global/broker/apply/info',
  BROKER_INFO: '/phemex-kol-global/broker/info',
  BROKER_DASHBOARD_COMMISSIONS: '/phemex-kol-global/broker/dashboard/summary/commission',
  BROKER_DASHBOARD_TRADE_VOLUME: '/phemex-kol-global/broker/dashboard/summary/trade',
  BROKER_DASHBOARD_TRADERS: '/phemex-kol-global/broker/dashboard/summary/trader',
  BROKER_DASHBOARD_WALLET: '/phemex-kol-global/broker/dashboard/summary/wallet',
  BROKER_DASHBOARD_EXPORT: '/phemex-kol-global/broker/dashboard/summary/export',
  BROKER_TRADERS: '/phemex-kol-global/broker/client',
  BROKER_CONTRACT_COMMISSIONS: '/phemex-kol-global/broker/trade/contract',
  BROKER_SPOT_COMMISSIONS: '/phemex-kol-global/broker/trade/spot',
  BROKER_ASSETS_SUMMARY: '/phemex-kol-global/broker/commission/sum',
  BROKER_ISSUED_COMMISSIONS: '/phemex-kol-global/broker/commission/total',
  BROKER_ISSUED_COMMISSION_DETAILS: '/phemex-kol-global/broker/commission/detail',

  // 机构看板
  VIP_QUERY_IS_INSTITUTIONAL_USER: '/phemex-activity/vip/data/isVipMember',
  VIP_INSTITUTIONAL_LAST_30_DAYS_DATA: '/phemex-activity/vip/data/thirty-data',
  VIP_INSTITUTIONAL_SUMMARY: '/phemex-activity/vip/data/summary',
  VIP_INSTITUTIONAL_DATA: '/phemex-activity/vip/data/symbol',
  VIP_INSTITUTIONAL_BASE_INFO: '/phemex-activity/vip/data/base-info',
  // 发币预热
  PT_PREHEAT_INFO: '/phemex-activity/public/data/pt/preheat/info',
  PT_PREHEAT_SIGN_UP: '/phemex-activity/pt/preheat/sign-up',
  PT_PREHEAT_USER_INFO: '/phemex-activity/pt/preheat/user-info',
  //PT 挖矿
  PT_MINING_USER_AWARD_HISTORY: '/phemex-pt-mining-app/award/history',

  //邮件订阅
  EMAIL_CONFIRM: '/phemex-activity/public/mail/info',
  EMAIL_UNSUBSCRIBE: '/phemex-activity/public/mail/unsubscribes',
  EMAIL_SUBSCRIBE: '/phemex-activity/public/mail/subscribes',

  // 统一账户 账户相关
  UTA_QUERY: '/phemex-account/users/unified-account/query', // GET 查询用户统一保证金账户升级情况
  UTA_SPOT_UPGRADE_ANSWER_COMPLETED: '/phemex-account/users/unified-account/spot-upgrade/answer-completed', // POST 现货统一保证金账户升级答题完成
  UTA_SPOT_UPGRADE_APPLY: '/phemex-account/users/unified-account/spot-upgrade/apply', // POST 现货统一保证金账户升级提交(单个账户)
  UTA_SPOT_UPGRADE_CHECK_SUB: '/phemex-account/users/unified-account/spot-upgrade/check-sub', // GET 现货统一保证金账户子账户升级条件判断
  UTA_SPOT_UPGRADE_APPLY_SUB: '/phemex-account/users/unified-account/spot-upgrade/apply-sub', // POST 现货统一保证金账户升级提交（批量子账户）
  EXPIRED_BONUS: '/contract-biz/bonus/expiring',

  // pt 手续费
  SPOT_PT_DISCOUNT: '/margin/currency/discount',
  CONTRACT_PT_DISCOUNT: '/g-accounts/set-account-status',

  // vePT 等级权益，买币获取空投
  VEPT_REWARD_INFO: '/phemex-uni-trade/reward/info',
  VEPT_AIRDROP_CONFIG: '/phemex-uni-trade/reward/getConfigurationsByPage',

  ACTIVITY_DETAIL: '/phemex-activity/public/data/activity/detail', // 按活动id获取活动详情（圣诞活动id固定为2003）
  ACTIVITY_APPLY: '/phemex-activity/activity/apply', // 用户报名活动（圣诞活动id固定为2003）
  ACTIVITY_CHRISTMAS_USER_INFO: '/phemex-activity/christmas/user-info', // 用户的圣诞活动奖励信息

  // welcome bonus
  BONUS_WELCOME_CONFIG: '/phemex-activity/public/data/welcome/config',
  BONUS_TASK_LIST: '/phemex-activity/operation/task/list',
  BONUS_PRIVILEGE_LOTTERY: '/phemex/marketing/privilege/lottery',
  BONUS_PRIVILEGE_DETAILS: '/phemex/marketing/privilege/details',

  //查询活动分组信息LeaderBoard
  SOCIAL_GROUP_INFO: '/phemex-uni-trade/group/im/chat/room/info',
  SOCIAL_SHARE_INFO: '/phemex-uni-trade/group/im/group/share/info',
  SOCIAL_SHARE_LINK: '/phemex-uni-trade/group/im/group/share/link',
  SOCIAL_PROFILE_EDIT: '/phemex-uni-trade/group/im/group/profile/edit',
  SOCIAL_GROUP_EDIT: '/phemex-im-server/im/group/profile/edit',
  SOCIAL_GROUP_TAG_EDIT: '/phemex-im-server/im/post/group/tag/edit',
  SOCIAL_PROFILE_QUERY: '/phemex-uni-trade/group/im/group/profile/query',
  SOCIAL_GROUP_BOARD: '/phemex-activity/social/group/board',
  SOCIAL_WEEK_STATISTIC: '/phemex-activity/social/user/week/statistic',
  SOCIAL_WEEK_SCORE: '/phemex-activity/social/user/week/score',
  SOCIAL_GROUP_LIST: '/phemex-activity/social/user/group',
  SOCIAL_TIME_PASS_OPEN: '/phemex-activity/time-pass/open',
  SOCIAL_LEADERBOARD_LIST: '/phemex-activity/public/md/social/leader-board/rank',
  SOCIAL_RAFFLE_LEADERBOARD_LIST: '/phemex-activity/public/data/social/raffle/rank',
  SOCIAL_RAFFLE_ORDERS: '/phemex-activity/social/cast/rewards/list',
  SOCIAL_TIME_PASS_IS_OPEN: '/phemex-activity/time-pass/is-open',
  SOCIAL_REWARD_POOL: '/phemex-activity/public/cfg/social/reward/pool',
  SOCIAL_MY_GROUPS: '/phemex-activity/social/v1/user/group',
  SOCIAL_REFRESH_MY_POINTS: '/phemex-activity/social/raffle/refresh',
  SOCIAL_MY_RAFFLE: '/phemex-activity/social/raffle/detail',
  SOCIAL_RAFFLE_CONFIG: '/phemex-activity/public/data/social/raffle/config',
  SOCIAL_WEEK_MY_POINTS: '/phemex-activity/social/v1/user/week/score',
  SOCIAL_USER_INFO: '/phemex-activity/social/user/info',
  SOCIAL_CONVERT_POINT: '/phemex-activity/social/score/exchange',
  SOCIAL_BUY_RAFFLE: '/phemex-activity/social/raffle/buy',
  SOCIAL_POINT_INVEST: '/phemex-activity/social/raffle/invest',
  SOCIAL_TIME_PASS_PRICE: '/phemex-activity/time-pass/price/inquiry',
  SOCIAL_TIME_PASS_ORDER: '/phemex-activity/time-pass/group/scroll',
  SOCIAL_GROUP_TIME_PASS: '/phemex-activity/time-pass/group/query',
  SOCIAL_MY_TIME_PASS: '/phemex-activity/time-pass/self/query',
  SOCIAL_TIME_PASS_BUY: '/phemex-activity/time-pass/buy',
  SOCIAL_TIME_PASS_SELL: '/phemex-activity/time-pass/sell',
  SOCIAL_EXIT_GROUP: '/phemex-uni-trade/group/im/leave/group',
  SOCIAL_GROUP_WEEK_DATA: '/phemex-activity/public/data/social/group/week/statistic',
  SOCIAL_USER_CONFIG: '/phemex-uni-trade/group/im/user/config',
  SOCIAL_USER_TODAY_POINT: '/phemex-activity/social/user/score/query',
  SOCIAL_EXCHANGE_INFO: '/phemex-activity/social/exchange/info',
  SOCIAL_CAST_LIST: '/phemex-im-server/im/post/page',
  SOCIAL_CAST_LIST_BY_KEYWORD: '/phemex-im-server/im/post/search',
  SOCIAL_CAST_LIST_BY_SORTMETHOD: '/phemex-im-server/im/post/v2/page',
  SOCIAL_PUBLIC_CAST_LIST_BY_SORTMETHOD: '/phemex-im-server/public/md/im/post/page',
  SOCIAL_POST_CAST: '/phemex-im-server/im/post/post',
  SOCIAL_POST_NEWCAST: '/phemex-im-server/im/post/post/v2',
  SOCIAL_CAST_LIKED: '/phemex-im-server/im/post/opinion',
  SOCIAL_CAST_CONFIG: '/phemex-activity/public/data/social/cast/config',
  SOCIAL_CAST_TIPPING: '/phemex-activity/social/cast/tip',
  SOCIAL_CAST_TIPPER: '/phemex-activity/social/cast/tip/info/list',
  SOCIAL_CAST_POINT: '/phemex-activity/social/cast/detail',
  SOCIAL_CAST_LEADERBOARD: '/phemex-activity/public/data/social/cast/rank',
  SOCIAL_TIPPING_LIST: '/phemex-activity/social/cast/tip/from/others',
  SOCIAL_TIPPING_RETURN_POING_LIST: '/phemex-activity/social/cast/tip/to/others',
  SOCIAL_CAST_CONTENT_CONFIG: '/phemex-im-server/im/post/cast/limit',
  SOCIAL_USER_WHITELIST: '/phemex-uni-trade/group/im/user/isWhiteList',
  SOCIAL_PULSER_LIST: '/phemex-im-server/im/post/user/search',
  SOCIAL_SHARE_REPORT: '/phemex-activity/social/pulse/shared/report',
  //social-trade apply moderator
  SOCIAL_MODERATOR_CONFIG: '/phemex-im-server/im/post/cast/limit',
  SOCIAL_MODERATOR_APPLY: '/phemex-im-server/im/role/moderator/apply',
  SOCIAL_MODERATOR_INFO: '/phemex-im-server/im/role/moderator/info',
  SOCIAL_CHAT_DELETE_MESSAGE_ITEM: '/phemex-im-server/im/channel/message',
  SOCIAL_USER_ROLE: '/phemex-im-server/im/role/get',
  SOCIAL_MUTE_USER: '/phemex-im-server/im/channel/user/mute',
  SOCIAL_UMMUTE_USER: '/phemex-im-server/im/channel/user/unmute',
  SOCIAL_BAN_USER: '/phemex-im-server/im/channel/user/ban',
  SOCIAL_UMBAN_USER: '/phemex-im-server/im/channel/user/unban',
  SOCIAL_MODERATOR_RECEIVED_POINT_LIST: '/phemex-activity/pulse/moderator/history',
  SOCIAL_GROUP_CATEGORY_LIST: '/phemex-activity/public/data/social/v1/group/category/list',
  SOCIAL_GROUP_TAG_LIST: '/phemex-im-server/im/post/category',
  SOCIAL_USER_PROFILE_UPDATE: '/phemex-activity/social/user/updateProfile',
  WEB3_SOCIAL_TRADE_DATA_VOLUME: '/pulse-social/public/data/social/data-volume',

  // social-trade mystery-box
  SOCIAL_MYSTERY_BOX_DATA: '/phemex-activity/public/data/mystery/data',
  SOCIAL_MYSTERY_BOX_CREATE: '/phemex-activity/mystery/create',
  SOCIAL_MYSTERY_BOX_NUMS: '/phemex-activity/mystery/nums',
  SOCIAL_MYSTERY_BOX_SHARE: '/phemex-activity/mystery/share',
  SOCIAL_MYSTERY_BOX_CONFIG: '/phemex-activity/public/info/mystery',

  //group pass
  SOCIAL_GROUP_PASS_DEPLOY: '/phemex-activity/group-pass/deploy',
  SOCIAL_GROUP_PASS_DEPLOY_DETAIL: '/phemex-activity/group-pass/deploy/info',
  SOCIAL_GROUP_PASS_MINT: '/phemex-activity/group-pass/mint',
  SOCIAL_GROUP_PASS_GROUP_LIST: '/phemex-activity/group-pass/group/list',
  SOCIAL_GROUP_PASS_GROUP_LIST_PUBLIC: '/phemex-activity/public/group-pass/group/list',
  SOCIAL_GROUP_PASS_GROUP: '/phemex-activity/group-pass/group',
  SOCIAL_GROUP_PASS_ORDER_BOOK_LIST: '/phemex-activity/group-pass/order/list',
  SOCIAL_GROUP_PASS_ORDER_BOOK_LIST_K: '/phemex-activity/group-pass/order/kline',
  SOCIAL_GROUP_PASS_MY_GROUP_AVAILABLE: '/phemex-activity/group-pass/available',
  SOCIAL_GROUP_PASS_MY_GROUP_ORDER_BOOK_LIST: '/phemex-activity/group-pass/order/my-group/list',
  SOCIAL_GROUP_PASS_PENDING_ORDER: '/phemex-activity/group-pass/order/pending',
  SOCIAL_GROUP_PASS_CANCEL_LIST: '/phemex-activity/group-pass/order/cancel',
  SOCIAL_GROUP_PASS_BUY: '/phemex-activity/group-pass/order/buy',
  SOCIAL_GROUP_PASS_MINT_INQUIRY: '/phemex-activity/group-pass/mint/inquiry',
  SOCIAL_GROUP_PASS_CONFIG: '/phemex-activity/public/group-pass/config',
  SOCIAL_PULSE_DROP_TASK: '/phemex-activity/pulse/drop/task',
  SOCIAL_PULSE_DROP_CONFIG: '/phemex-activity/public/data/pulse/drop/activity/get',
  SOCIAL_PULSE_DROP_TASK_ADD: '/phemex-activity/pulse/drop/fetch',
  SOCIAL_PULSE_PROFILE: '/phemex-activity/social/user/info',
  SOCIAL_PULSE_USER_CAST_LIST: '/phemex-im-server/im/post/user/home/query',

  // security passkey
  PASSKEY_ENABLE: '/phemex-user/users/passkey/verify',
  PASSKEY_WITHDRAW_START: '/phemex-user/users/passkey/verify/start',
  PASSKEY_REGISTER: '/phemex-user/users/passkey/register/start',
  PASSKEY_FINISHED: '/phemex-user/users/passkey/register/finish',
  PASSKEY_LIST: '/phemex-user/users/passkey/credential/all',
  PASSKEY_REMOVE: '/phemex-user/users/passkey/credential/delete',
  PASSKEY_RENAME: '/phemex-user/users/passkey/device/modify',
  PASSKEY_CHECK: '/phemex-user/public/users/verify/filter',
  PASSKEY_LOGIN: '/phemex-user/users/passkey/auth/login',
  PASSKEY_CONFIRM_LOGIN: '/phemex-user/users/passkey/auth/confirm/login',

  // price page
  GET_CURRENCY_EXCHANGE_RATE: '/phemex-activity/public/md/query/exchange/rate',
  GET_FIAT_LIST: '/phemex-activity/public/md/query/currency-list',
  GET_PRICE_DETAIL: '/phemex-activity/public/md/query/coin-detail',
  GET_COIN_ABOUT: '/phemex-activity/public/data/price/page/coin/detail',

  // cs
  IM_ROBOT_INFO: '/phemex-im-server/public/data/zendesk/robot',
  IM_CS_EVALUATION: '/phemex-im-server/public/data/zendesk/csat',

  // Lending
  LENDING_POOL: '/phemex-lending/pool', // GET
  LENDING_PUBLIC_DATA_POOL: '/phemex-lending/public/data/pool', // GET
  LENDING_ASSETS_OVERVIEW: '/phemex-lending/assets/overview', // GET
  LENDING_HIST_COLLATERAL: '/phemex-lending/hist/collateral', // GET
  LENDING_HIST_LIQ: '/phemex-lending/hist/liq', // GET
  LENDING_HIST_LOAN: '/phemex-lending/hist/loan', // GET
  LENDING_HIST_PAYBACK: '/phemex-lending/hist/payback', // GET
  LENDING_HIST_INTEREST: '/phemex-lending/hist/loan/interests', // GET
  LENDING_HIST_FUNDS: '/phemex-lending/hist/funds', // GET
  LENDING_LOAN_ACTIVE: '/phemex-lending/loan/active', // GET
  LENDING_LOAN_QUOTA: '/phemex-lending/loan/quota', // GET
  LENDING_PUBLIC_DATA_APR: '/phemex-lending/public/data/apr', // GET
  LENDING_LOAN: '/phemex-lending/loan', // POST
  LENDING_INTERNAL_POOL_CONFIG: '/phemex-lending/internal/pool/config', // POST
  LENDING_INTERNAL_POOL_CONFIG_DB: '/phemex-lending/internal/pool/config-db', // POST
  LENDING_LOAN_ADD_COLLATERAL: '/phemex-lending/loan/add-collateral', // POST
  LENDING_PAYBACK: '/phemex-lending/payback', // POST
  LENDING_ACCOUNTS_OPEN: '/phemex-account/accounts/lending/open', // POST
  LENDING_SUPPORT_CURRENCIES: '/phemex-lending/public/data/supported-currencies',
  LENDING_SUPPLY: '/phemex-lending/supply', // POST
  LENDING_REDEEM: '/phemex-lending/redeem', // POST
  LENDING_AUTO_INVEST: '/phemex-lending/auto-invest', // POST
  LENDING_ASSETS_ACCOUNT_SUPPLY: '/phemex-lending/assets/account/supply', // GET
  LENDING_SUPPLY_ACTIVE: '/phemex-lending/supply/active', // GET
  LENDING_HIST_SUPPLY: '/phemex-lending/hist/supply', // GET
  LENDING_HIST_SUPPLY_REDEMPTION: '/phemex-lending/hist/redeem	', // GET
  LENDING_HIST_SUPPLY_INTEREST: '/phemex-lending/hist/supply/interests', // GET

  // withdraw lock
  SETTINGS_QUERY: '/phemex-account/users/settings/query',
  SETTINGS_MODIFY: '/phemex-account/users/settings/modify',
  PUBLIC_SETTINGS_MODIFY: '/phemex-account/public/users/settings/modify',
  SETTINGS_MULTI_MODIFY: '/phemex-account/users/settings/multi/modify',
  SETTINGS_QUERY_OPTIONS: '/phemex-account/users/settings/queryOptions',
  ADDRESS_NOTE: '/phemex-withdraw/wallets/withdraw-address',
  UID_ADDRESS_NOTE: '/phemex-withdraw/wallets/inside/withdraw-address',
  ADDRESS_DELETE: '/phemex-wallet/wallets/withdraw-address',
  WITHDRAW_ADDRESSLIST: '/phemex-withdraw/wallets/withdraw-address',
  DELETE_WITHDRAWADDRESS: '/phemex-withdraw/wallets/withdraw-address',
  WITHDRAW_INTERNAL_ADDRESS_DELETE: '/phemex-withdraw/wallets/inside/v2/address',
  WALLETS_WITHDRAW_ADDRESS_EXPORT: '/phemex-wallet/wallets/withdraw-address-export',
  INSIDE_WITHDRAW_ADDRESS_EXPORT: '/phemex-withdraw/wallets/inside/withdraw-address-export',
  WITHDRAW_ACCOUNT_CFG: '/phemex-withdraw/wallets/user-cfg/withdraw-account-cfg',

  // convert
  WALLETS_CONVERSIONS: '/exchanger-core/wallets/tiny/v1/conversions',
  WALLETS_CONVERSIONS_DETAIL: '/exchanger-core/wallets/tiny/v1/conversion/detail',

  // pt conversion
  CONVERSION_SUPPORTED_CCY: '/exchanger-core/wallets/public/data/tiny/conversion/supported-ccy',
  TINY_CONVERSION_QUOTE: '/exchanger-core/wallets/tiny/v1/conversion/quote',
  TINY_CONVERSION: '/exchanger-core/wallets/tiny/v1/conversion',
  TINY_CONVERSION_DETAIL: '/exchanger-core/wallets/tiny/v1/conversion/detail',

  // Assets data
  DATA_ASSETS_OVERVIEW: '/margin/assets/overview',

  // watchlist
  MARKET_FAVORITE_GROUPS: '/phemex-account/users/favorite/group/query-all',
  MARKET_FAVORITE_GROUPS_ADD: '/phemex-account/users/favorite/group/add',
  MARKET_FAVORITE_GROUPS_DELETE: '/phemex-account/users/favorite/group/delete',
  MARKET_FAVORITE_GROUPS_RENAME: '/phemex-account/users/favorite/group/rename',
  MARKET_FAVORITE_INSTRUMENT_add: '/phemex-account/users/favorite/instrument/add',
  MARKET_FAVORITE_INSTRUMENT_DELETE: '/phemex-account/users/favorite/instrument/delete',
  MARKET_FAVORITE_INSTRUMENT_TOP: '/phemex-account/users/favorite/instrument/top',
  MARKET_FAVORITE_INSTRUMENT_SORT: '/phemex-account/users/favorite/instrument/sort',
  MARKET_FAVORITE_SHARE: '/phemex-account/users/favorite/group/share',
  MARKET_FAVORITE_GROUP_IMPORT: '/phemex-account/users/favorite/group/import',

  // contract
  CONTRACT_DAILY_BOARD: '/phemex-activity/contract/board/daily',
  CONTRACT_RANKING_BOARD: '/phemex-activity/contract/board/periodic',
  CONTRACT_PUBLIC_DAILY_BOARD: '/phemex-activity/public/data/contract/board/daily',
  CONTRACT_PUBLIC_RANKING_BOARD: '/phemex-activity/public/data/contract/board/periodic',

  CONTRACT_BOARD_FOLLOW_LIST: '/phemex-activity/contract/board/follow/list',
  CONTRACT_BOARD_FOLLOW: '/phemex-activity/contract/board/follow',
  CONTRACT_BOARD_USER_SHARE_SETTING: '/phemex-activity/contract/board/setting',
  CONTRACT_BOARD_USER_SHARE_INFO: '/phemex-activity/contract/board/info',
  CONTRACT_BOARD_PUBLIC_USER_SHARE_INFO: '/phemex-activity/public/data/contract/board/info',
  CONTRACT_BOARD_USER_SHARE_SETTING_UPDATE: '/phemex-activity/contract/board/update',
  CONTRACT_BOARD_HISTORY: '/phemex-activity/public/data/contract/board/history',
  CONTRACT_BOARD_USER_DAILY_DATA: '/phemex-activity/public/data/contract/board/daily/user',
  CONTRACT_BOARD_USER_PERIODIC_DATA: '/phemex-activity/public/data/contract/board/periodic/user',
  CONTRACT_BOARD_USER_POSITION_LIST: '/phemex-activity/public/data/contract/board/position',
  CONTRACT_BOARD_PUBLIC_FOLLOWING_LIST: '/phemex-activity/public/data/contract/board/follow/list',
  CONTRACT_BOARD_PUBLIC_FOLLOWER_LIST: '/phemex-activity/public/data/contract/board/fan/list',
  CONTRACT_BOARD_FOLLOWING_LIST: '/phemex-activity/contract/board/follow/list',
  CONTRACT_BOARD_FOLLOWER_LIST: '/phemex-activity/contract/board/fan/list',
  //KOL 专属活动
  EXCLUSIVE_ACTIVITY_INFO: '/phemex-activity/public/data/exclusive/config-info',
  USER_EXCLUSIVE_ACTIVITY_INFO: '/phemex-activity/exclusive/user-activity-info',
  USER_CLAIM_EXCLUSIVE_ACTIVITY: '/phemex-activity/exclusive/user-claim',
  MEME_HISTORY_FUNDS: '/phemex-meme/meme/hist/funds',
  MEME_LIST: '/phemex-meme/meme/public/data/list',
  MEME_LIST_UPDATE: '/phemex-meme/meme/list/update',
  MEME_PUBLIC_LIST_UPDATE: '/phemex-meme/meme/public/md/update',
  KOL_TRADING_LEADERS_COMMSSION_SHARE: '/phemex-kol-global/agent/commission/leaderDetail',

  // partner dashboard
  PARTNER_COMMISSION_SUMMARY: '/phemex-kol-global/partner/dashboard/summary/commission',
  PARTNER_TRADE_SUMMARY: '/phemex-kol-global/partner/dashboard/summary/trade',
  PARTNER_REFERRAL_SUMMARY: '/phemex-kol-global/partner/dashboard/summary/referral',
  PARTNER_REFERRAL_TRADE_SUMMARY: '/phemex-kol-global/partner/dashboard/summary/referral-trade',
  PARTNER_DASHBOARD_WALLET_SUMMARY: '/phemex-kol-global/partner/dashboard/summary/wallet',
  PARTNER_DASHBOARD_DEPOSIT_SUMMARY: '/phemex-kol-global/partner/dashboard/summary/deposit',
  PARTNER_DASHBOARD_EXPORT: '/phemex-kol-global/partner/dashboard/summary/export',

  PARTNER_LIST: '/phemex-kol-global/partner/manage/list',
  PARTNER_DETAIL: '/phemex-kol-global/partner/manage/detail/{partnerUid}',
  PARTNER_UPDATE_COMMISSION_RATE: '/phemex-kol-global/partner/manage/commission/update',
  PARTNER_COMMISSION_RATE_LOGS: '/phemex-kol-global/partner/manage/commission/history',
  PARTNER_COMMISSION_RATE: '/phemex-kol-global/partner/manage/commission/rate',
  PARTNER_TRANSACTION_QUERY: '/phemex-kol-global/partner/commission/statistics/query',
  PARTNER_TRANSACTION_DETAIL: '/phemex-kol-global/partner/commission/transaction/details',

  PARTNER_DIRECT_CUSTOMER_LIST: '/phemex-kol-global/partner/manage/direct-customer/query',
  PARTNER_DIRECT_CUSTOMER_TRADES: '/phemex-kol-global/partner/commission/direct-customer/trades',
  PARTNER_UPGRADE_TO_PARTNER: '/phemex-kol-global/partner/manage/upgrade',
  PARTNER_DIRECT_CUSTOMER_COMMISSIONS: '/phemex-kol-global/partner/commission/direct-commission/details',
  PARTNER_NON_DIRECT_CUSTOMER_COMMISSIONS: '/phemex-kol-global/partner/commission/non-direct-commission/details',

  PARTNER_ALL_CURRENCY: '/phemex-kol-global/partner/general/allCurrency',
  PARTNER_ALL_GROUP: '/phemex-kol-global/partner/general/allGroup',

  PARTNER_GROUP_LIST: '/phemex-kol-global/partner/group/list',
  PARTNER_ADD_GROUP: '/phemex-kol-global/partner/group/add',
  PARTNER_UPDATE_GROUP_STATUS: '/phemex-kol-global/partner/group/status',
  PARTNER_UPDATE_CASHBACK: '/phemex-kol-global/partner/group/cashback',

  PARTNER_USER_PROFILE: '/phemex-kol-global/partner/userProfile',
  PARTNER_WALLET_BALANCE: '/phemex-kol-global/partner/wallet/balance',
  PARTNER_WALLET_SUMMARY: '/phemex-kol-global/partner/wallet/summary',
  PARTNER_WITHDRAW_ALL: '/phemex-kol-global/partner/wallet/withdraw/all',
  PARTNER_WALLET_RECORD_LIST: '/phemex-kol-global/partner/wallet/record/list',
  PARTNER_WITHDRAW: '/phemex-kol-global/partner/wallet/withdraw',
  PARTNER_ACCOUNT_INFO: '/phemex-kol-global/partner/general/info',

  PARTNER_TRADING_LEADERS_COMMSSION_SHARE: '/phemex-kol-global/partner/commission/leader/details',
  PARTNER_TRADING_LEADERS_BOTS_SHARE: '/phemex-kol-global/leader/share',
  LEADER_COMMISSION_SHARE_TOTAL: '/phemex-kol-global/leader/total',
  LEADER_COMMISSION_SHARE_LIST: '/phemex-kol-global/leader/commission',
  PARTNERS_RELATED: '/phemex-kol-global/leader/partners',

  // 抽奖
  PRIZE_POOL_LIST: '/phemex/marketing/public/activity/template/list',
  LOTTERY_BY_QUALIFICATIONID: '/phemex/marketing/privilege/lottery',
  SCROLL_PRIVILEGE: '/phemex/marketing/public/md/scroll-privilege',
  REWARDS_LIST: '/phemex/marketing/privilege/condition/list',
  TASK_LIST: '/phemex-activity/public/data/campaign/task/query',
  INVITE_LIST: '/phemex-activity/campaign/referral/list',
  LOTTERY_DETAIL: '/phemex/marketing/privilege/details',
};

Object.keys(API_URLS).forEach((key) => (API_URLS[key] = [SERVICES.API, API_URLS[key]].join('')));
